/* eslint-disable */
import * as schema from '../schema';
import { DayOfWeek, Instant, LocalDate, LocalDateTime, LocalTime } from "@js-joda/core"
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AgencyBranchId: { input: schema.AgencyBranchId; output: schema.AgencyBranchId; }
  AgencyId: { input: schema.AgencyId; output: schema.AgencyId; }
  AgencyMemberId: { input: schema.AgencyMemberId; output: schema.AgencyMemberId; }
  AgencyPhonebookContactId: { input: schema.AgencyPhonebookContactId; output: schema.AgencyPhonebookContactId; }
  AgencyTeamId: { input: schema.AgencyTeamId; output: schema.AgencyTeamId; }
  Any: { input: any; output: any; }
  AuthorizationId: { input: schema.AuthorizationId; output: schema.AuthorizationId; }
  AuthorizationTimeConfig: { input: schema.components["schemas"]["AuthorizationTimeConfig"]; output: schema.components["schemas"]["AuthorizationTimeConfig"]; }
  CaregiverCertification: { input: schema.components["schemas"]["CaregiverCertification"]; output: schema.components["schemas"]["CaregiverCertification"]; }
  CaregiverId: { input: schema.CaregiverId; output: schema.CaregiverId; }
  CaregiverStatus: { input: schema.components["schemas"]["CaregiverStatus"]; output: schema.components["schemas"]["CaregiverStatus"]; }
  CaregiverVisitEngagementId: { input: unknown; output: unknown; }
  CertificationPeriodId: { input: schema.CertificationPeriodId; output: schema.CertificationPeriodId; }
  CommCenterLabelId: { input: schema.CommCenterLabelId; output: schema.CommCenterLabelId; }
  CommCenterMessageActionId: { input: schema.CommCenterMessageActionId; output: schema.CommCenterMessageActionId; }
  CommCenterTeamId: { input: schema.CommCenterTeamId; output: schema.CommCenterTeamId; }
  CommCenterTicketId: { input: schema.CommCenterTicketId; output: schema.CommCenterTicketId; }
  ContractTypeId: { input: schema.ContractTypeId; output: schema.ContractTypeId; }
  EntityCustomField: { input: schema.components["schemas"]["EntityCustomField"]; output: schema.components["schemas"]["EntityCustomField"]; }
  Geo: { input: schema.components["schemas"]["Geo"]; output: schema.components["schemas"]["Geo"]; }
  ImportedVisitId: { input: schema.ImportedVisitId; output: schema.ImportedVisitId; }
  Instant: { input: Instant; output: Instant; }
  LocalDate: { input: LocalDate; output: LocalDate; }
  LocalDateTime: { input: LocalDateTime; output: LocalDateTime; }
  MedflytCHRCDataId: { input: schema.MedflytCHRCDataId; output: schema.MedflytCHRCDataId; }
  MedflytHCRDataId: { input: schema.MedflytHCRDataId; output: schema.MedflytHCRDataId; }
  NoteId: { input: schema.NoteId; output: schema.NoteId; }
  OfficeId: { input: schema.OfficeId; output: schema.OfficeId; }
  PatientContractId: { input: schema.PatientContractId; output: schema.PatientContractId; }
  PatientGender: { input: schema.components["schemas"]["Patient"]["gender"]; output: schema.components["schemas"]["Patient"]["gender"]; }
  PatientId: { input: schema.PatientId; output: schema.PatientId; }
  PatientIssueId: { input: schema.PatientIssueId; output: schema.PatientIssueId; }
  PatientStatus: { input: schema.components["schemas"]["PatientStatus"]; output: schema.components["schemas"]["PatientStatus"]; }
  PatientTaskId: { input: schema.PatientTaskId; output: schema.PatientTaskId; }
  PatientTaskInstanceId: { input: schema.PatientTaskInstanceId; output: schema.PatientTaskInstanceId; }
  PatientWebsiteVisitorEventId: { input: unknown; output: unknown; }
  PatientWebsiteVisitorId: { input: unknown; output: unknown; }
  PatientWebsiteVisitorVisitId: { input: unknown; output: unknown; }
  PayerId: { input: schema.PayerId; output: schema.PayerId; }
  PermissionControlledField_DayOfWeek: { input: PermissionControlledField_DayOfWeek; output: PermissionControlledField_DayOfWeek; }
  PermissionControlledField_Instant: { input: PermissionControlledField_Instant; output: PermissionControlledField_Instant; }
  PermissionControlledField_LocalDate: { input: PermissionControlledField_LocalDate; output: PermissionControlledField_LocalDate; }
  PermissionControlledField_LocalDateTime: { input: PermissionControlledField_LocalDateTime; output: PermissionControlledField_LocalDateTime; }
  ReferralUserId: { input: schema.ReferralUserId; output: schema.ReferralUserId; }
  ServiceCodeId: { input: schema.ServiceCodeId; output: schema.ServiceCodeId; }
  UserId: { input: schema.UserId; output: schema.UserId; }
  VisitAssignmentId: { input: schema.VisitAssignmentId; output: schema.VisitAssignmentId; }
  VisitBroadcastId: { input: schema.VisitBroadcastId; output: schema.VisitBroadcastId; }
  VisitInstanceId: { input: schema.VisitInstanceId; output: schema.VisitInstanceId; }
  WorkflowDefinitionCorrelationKey: { input: schema.WorkflowDefinitionCorrelationKey; output: schema.WorkflowDefinitionCorrelationKey; }
  WorkflowDefinitionId: { input: schema.WorkflowDefinitionId; output: schema.WorkflowDefinitionId; }
  WorkflowDefinitionTriggerId: { input: schema.WorkflowDefinitionTriggerId; output: schema.WorkflowDefinitionTriggerId; }
  WorkflowExecutionValueObject: { input: schema.components["schemas"]["WorkflowExecutionValueObject"]; output: schema.components["schemas"]["WorkflowExecutionValueObject"]; }
  WorkflowInputs: { input: schema.components["schemas"]["WorkflowInputs"]; output: schema.components["schemas"]["WorkflowInputs"]; }
  WorkflowInstanceId: { input: schema.WorkflowInstanceId; output: schema.WorkflowInstanceId; }
  WorkflowInstanceOrigin: { input: schema.components["schemas"]["WorkflowInstanceOrigin"]; output: schema.components["schemas"]["WorkflowInstanceOrigin"]; }
  WorkflowSkillId: { input: schema.WorkflowSkillId; output: schema.WorkflowSkillId; }
  WorkflowTagId: { input: schema.WorkflowTagId; output: schema.WorkflowTagId; }
  WorkflowTaskClusterId: { input: schema.WorkflowTaskClusterId; output: schema.WorkflowTaskClusterId; }
  WorkflowTaskInstanceId: { input: schema.WorkflowTaskInstanceId; output: schema.WorkflowTaskInstanceId; }
};

export type AgencyBranch = {
  __typename?: 'AgencyBranch';
  id: Scalars['AgencyBranchId']['output'];
  name: Scalars['String']['output'];
  patients: AgencyBranchPatientAssocConnection;
};


export type AgencyBranchPatientsArgs = {
  agencyBranch?: InputMaybe<AgencyBranch_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patient?: InputMaybe<Patient_RelationFilter>;
};

export type AgencyBranchConnection = {
  __typename?: 'AgencyBranchConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyBranch>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

/** Filter result rows based on the value of a field */
export type AgencyBranchId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['AgencyBranchId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['AgencyBranchId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['AgencyBranchId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['AgencyBranchId']['input']>>;
};

export type AgencyBranchPatientAssoc = {
  __typename?: 'AgencyBranchPatientAssoc';
  agencyBranch: AgencyBranch;
  agencyBranchId: Scalars['AgencyBranchId']['output'];
  patient: Patient;
  patientId: Scalars['PatientId']['output'];
};

export type AgencyBranchPatientAssocConnection = {
  __typename?: 'AgencyBranchPatientAssocConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyBranchPatientAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyBranch_RelationFilter = {
  /** Filter based on "id" field */
  id?: InputMaybe<AgencyBranchId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
};

export type AgencyBranch__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyBranch__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyBranch__OrderField {
  Id = 'id',
  Name = 'name'
}

/** Filter result rows based on the value of a field */
export type AgencyId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['AgencyId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['AgencyId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['AgencyId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['AgencyId']['input']>>;
};

export type AgencyMemberAgency = {
  __typename?: 'AgencyMemberAgency';
  id: Scalars['AgencyId']['output'];
  name: Scalars['String']['output'];
  website: Scalars['String']['output'];
};

export type AgencyMemberAgencyConnection = {
  __typename?: 'AgencyMemberAgencyConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberAgency>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberAgencyMember = {
  __typename?: 'AgencyMemberAgencyMember';
  agency: AgencyMemberAgency;
  agencyId: Scalars['AgencyId']['output'];
  firstName: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  id: Scalars['AgencyMemberId']['output'];
  lastName: Scalars['String']['output'];
  offices: AgencyMemberOfficeAssocConnection;
  photoUrl?: Maybe<Scalars['String']['output']>;
};


export type AgencyMemberAgencyMemberOfficesArgs = {
  agencyMember?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  office?: InputMaybe<AgencyMemberOffice_RelationFilter>;
  officeId?: InputMaybe<OfficeId_Filter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberOfficeAssoc__Order>>>;
};

export type AgencyMemberAgencyMemberConnection = {
  __typename?: 'AgencyMemberAgencyMemberConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberAgencyMember>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberAgencyMember_RelationFilter = {
  /** Filter based on "agencyId" field */
  agencyId?: InputMaybe<AgencyId_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<AgencyMemberId_Filter>;
  /** Search by first name or last name */
  nameSearch?: InputMaybe<Scalars['String']['input']>;
};

export type AgencyMemberAgencyMember__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberAgencyMember__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberAgencyMember__OrderField {
  AgencyId = 'agencyId',
  Id = 'id'
}

export type AgencyMemberAgency_RelationFilter = {
  /** Filter based on "id" field */
  id?: InputMaybe<AgencyId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
};

export type AgencyMemberAgency__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberAgency__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberAgency__OrderField {
  Id = 'id',
  Name = 'name'
}

export type AgencyMemberAvailableWorkflowTaskInstance = {
  __typename?: 'AgencyMemberAvailableWorkflowTaskInstance';
  assignee?: Maybe<AgencyMemberAgencyMember>;
  assigneeId?: Maybe<Scalars['AgencyMemberId']['output']>;
  assignmentTimeoutSeconds?: Maybe<Scalars['Int']['output']>;
  clusterId?: Maybe<Scalars['WorkflowTaskClusterId']['output']>;
  clusterValue?: Maybe<Scalars['String']['output']>;
  correlationKey: Scalars['WorkflowDefinitionCorrelationKey']['output'];
  createdAt: Scalars['Instant']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['WorkflowTaskInstanceId']['output'];
  instanceEntities: AgencyMemberWorkflowInstanceInputEntitiesConnection;
  mandatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  ownerId: Scalars['AgencyMemberId']['output'];
  priority: Scalars['Int']['output'];
  severity: Scalars['String']['output'];
  skills: AgencyMemberWorkflowTaskSkillConnection;
  workflowDefinition: AgencyMemberWorkflowDefinition;
  workflowDefinitionId: Scalars['WorkflowDefinitionId']['output'];
  workflowDefinitionName: Scalars['String']['output'];
  workflowInstanceId: Scalars['WorkflowInstanceId']['output'];
  workflowTaskDefinitionId: Scalars['String']['output'];
};


export type AgencyMemberAvailableWorkflowTaskInstanceInstanceEntitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AgencyMemberAvailableWorkflowTaskInstanceSkillsArgs = {
  id?: InputMaybe<WorkflowSkillId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowTaskSkill__Order>>>;
  workflowTaskInstanceId?: InputMaybe<WorkflowTaskInstanceId_Filter>;
};

export type AgencyMemberAvailableWorkflowTaskInstanceConnection = {
  __typename?: 'AgencyMemberAvailableWorkflowTaskInstanceConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberAvailableWorkflowTaskInstance>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberAvailableWorkflowTaskInstance__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberAvailableWorkflowTaskInstance__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberAvailableWorkflowTaskInstance__OrderField {
  AssigneeId = 'assigneeId',
  ClusterId = 'clusterId',
  CorrelationKey = 'correlationKey',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Mandatory = 'mandatory',
  Name = 'name',
  OwnerId = 'ownerId',
  Priority = 'priority',
  Severity = 'severity',
  WorkflowDefinitionId = 'workflowDefinitionId',
  WorkflowDefinitionName = 'workflowDefinitionName',
  WorkflowInstanceId = 'workflowInstanceId',
  WorkflowTaskDefinitionId = 'workflowTaskDefinitionId'
}

export type AgencyMemberCaregiver = {
  __typename?: 'AgencyMemberCaregiver';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  branches: AgencyMemberCaregiverBranchAssocConnection;
  caregiverCode?: Maybe<Scalars['String']['output']>;
  certifications: Array<Scalars['CaregiverCertification']['output']>;
  chrcCompliance?: Maybe<AgencyMemberCaregiverChrcCompliance>;
  createdAt: Scalars['Instant']['output'];
  dateOfBirth?: Maybe<Scalars['LocalDate']['output']>;
  displayId?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  gender: Scalars['PatientGender']['output'];
  hcrCompliance?: Maybe<AgencyMemberCaregiverHcrCompliance>;
  hireDate?: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['CaregiverId']['output'];
  languages: Array<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  offices: CaregiverOfficeAssocConnection;
  phoneNumbers: AgencyMemberCaregiverPhoneNumberConnection;
  ssn?: Maybe<Scalars['String']['output']>;
  stateRegistryNum?: Maybe<Scalars['Int']['output']>;
  status: Scalars['CaregiverStatus']['output'];
  terminationDate?: Maybe<Scalars['LocalDate']['output']>;
  visitBroadcasts: VisitBroadcastBroadcastedToConnection;
  visitInstances: AgencyMemberVisitInstanceConnection;
  workAreaPreference?: Maybe<Scalars['String']['output']>;
};


export type AgencyMemberCaregiverBranchesArgs = {
  agencyBranch?: InputMaybe<AgencyBranch_RelationFilter>;
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AgencyMemberCaregiverOfficesArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  office?: InputMaybe<AgencyMemberOffice_RelationFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AgencyMemberCaregiverPhoneNumbersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AgencyMemberCaregiverVisitBroadcastsArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<VisitBroadcastBroadcastedTo__Order>>>;
  visitBroadcast?: InputMaybe<AgencyMemberVisitBroadcast_RelationFilter>;
};


export type AgencyMemberCaregiverVisitInstancesArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']['input']>;
  id?: InputMaybe<VisitInstanceId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberVisitInstance__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
};

export type AgencyMemberCaregiverBranchAssoc = {
  __typename?: 'AgencyMemberCaregiverBranchAssoc';
  agencyBranch: AgencyBranch;
  agencyBranchId: Scalars['AgencyBranchId']['output'];
  caregiver: AgencyMemberCaregiver;
  caregiverId: Scalars['CaregiverId']['output'];
};

export type AgencyMemberCaregiverBranchAssocConnection = {
  __typename?: 'AgencyMemberCaregiverBranchAssocConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberCaregiverBranchAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberCaregiverChrcCompliance = {
  __typename?: 'AgencyMemberCaregiverChrcCompliance';
  caregiver?: Maybe<AgencyMemberCaregiver>;
  caregiverId?: Maybe<Scalars['CaregiverId']['output']>;
  chrcDateOfBirth: Scalars['LocalDate']['output'];
  chrcEmployeeName: Scalars['String']['output'];
  chrcStartDate: Scalars['LocalDate']['output'];
  chrcStatus: Scalars['String']['output'];
  chrcStatusDate: Scalars['LocalDate']['output'];
  dateOfBirth?: Maybe<Scalars['LocalDate']['output']>;
  hireDate?: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['MedflytCHRCDataId']['output'];
  stateRegistryNum?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['CaregiverStatus']['output']>;
  terminationDate?: Maybe<Scalars['LocalDate']['output']>;
};

export type AgencyMemberCaregiverChrcComplianceConnection = {
  __typename?: 'AgencyMemberCaregiverChrcComplianceConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberCaregiverChrcCompliance>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberCaregiverChrcCompliance_RelationFilter = {
  /** Filter based on "caregiverId" field */
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']['input']>>;
  /** Filter based on "chrcDateOfBirth" field */
  chrcDateOfBirth?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "chrcEmployeeName" field */
  chrcEmployeeName?: InputMaybe<String_Filter>;
  /** Filter based on "chrcStartDate" field */
  chrcStartDate?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "chrcStatus" field */
  chrcStatus?: InputMaybe<String_Filter>;
  /** Filter based on "chrcStatusDate" field */
  chrcStatusDate?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "dateOfBirth" field */
  dateOfBirth?: InputMaybe<LocalDate_Filter>;
  fromChrcStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  fromHireDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Filter based on "hireDate" field */
  hireDate?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<MedflytChrcDataId_Filter>;
  onlyUnmatched?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter based on "stateRegistryNum" field */
  stateRegistryNum?: InputMaybe<Int_Filter>;
  /** Filter based on "status" field */
  status?: InputMaybe<String_Filter>;
  /** Filter based on "terminationDate" field */
  terminationDate?: InputMaybe<LocalDate_Filter>;
  toChrcStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  toHireDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type AgencyMemberCaregiverChrcCompliance__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberCaregiverChrcCompliance__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberCaregiverChrcCompliance__OrderField {
  CaregiverId = 'caregiverId',
  ChrcDateOfBirth = 'chrcDateOfBirth',
  ChrcEmployeeName = 'chrcEmployeeName',
  ChrcStartDate = 'chrcStartDate',
  ChrcStatus = 'chrcStatus',
  ChrcStatusDate = 'chrcStatusDate',
  DateOfBirth = 'dateOfBirth',
  HireDate = 'hireDate',
  Id = 'id',
  StateRegistryNum = 'stateRegistryNum',
  Status = 'status',
  TerminationDate = 'terminationDate'
}

export type AgencyMemberCaregiverConnection = {
  __typename?: 'AgencyMemberCaregiverConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberCaregiver>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberCaregiverHcrCompliance = {
  __typename?: 'AgencyMemberCaregiverHcrCompliance';
  caregiver?: Maybe<AgencyMemberCaregiver>;
  caregiverId?: Maybe<Scalars['CaregiverId']['output']>;
  dateOfBirth?: Maybe<Scalars['LocalDate']['output']>;
  hcrCertificateType: Scalars['String']['output'];
  hcrDateOfBirth: Scalars['LocalDate']['output'];
  hcrFullName: Scalars['String']['output'];
  hcrHireDate?: Maybe<Scalars['LocalDate']['output']>;
  hcrSeparationDate?: Maybe<Scalars['LocalDate']['output']>;
  hcrStateRegistryNumber?: Maybe<Scalars['Int']['output']>;
  hireDate?: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['MedflytHCRDataId']['output'];
  stateRegistryNum?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['CaregiverStatus']['output']>;
  terminationDate?: Maybe<Scalars['LocalDate']['output']>;
};

export type AgencyMemberCaregiverHcrComplianceConnection = {
  __typename?: 'AgencyMemberCaregiverHcrComplianceConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberCaregiverHcrCompliance>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberCaregiverHcrCompliance_RelationFilter = {
  /** Filter based on "caregiverId" field */
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']['input']>>;
  /** Filter based on "dateOfBirth" field */
  dateOfBirth?: InputMaybe<LocalDate_Filter>;
  fromHireDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Filter based on "hcrCertificateType" field */
  hcrCertificateType?: InputMaybe<String_Filter>;
  /** Filter based on "hcrDateOfBirth" field */
  hcrDateOfBirth?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "hcrFullName" field */
  hcrFullName?: InputMaybe<String_Filter>;
  /** Filter based on "hcrHireDate" field */
  hcrHireDate?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "hcrSeparationDate" field */
  hcrSeparationDate?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "hcrStateRegistryNumber" field */
  hcrStateRegistryNumber?: InputMaybe<Int_Filter>;
  /** Filter based on "hireDate" field */
  hireDate?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<MedflytHcrDataId_Filter>;
  onlyUnmatched?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter based on "stateRegistryNum" field */
  stateRegistryNum?: InputMaybe<Int_Filter>;
  /** Filter based on "status" field */
  status?: InputMaybe<String_Filter>;
  /** Filter based on "terminationDate" field */
  terminationDate?: InputMaybe<LocalDate_Filter>;
  toHireDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type AgencyMemberCaregiverHcrCompliance__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberCaregiverHcrCompliance__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberCaregiverHcrCompliance__OrderField {
  CaregiverId = 'caregiverId',
  DateOfBirth = 'dateOfBirth',
  HcrCertificateType = 'hcrCertificateType',
  HcrDateOfBirth = 'hcrDateOfBirth',
  HcrFullName = 'hcrFullName',
  HcrHireDate = 'hcrHireDate',
  HcrSeparationDate = 'hcrSeparationDate',
  HcrStateRegistryNumber = 'hcrStateRegistryNumber',
  HireDate = 'hireDate',
  Id = 'id',
  StateRegistryNum = 'stateRegistryNum',
  Status = 'status',
  TerminationDate = 'terminationDate'
}

export type AgencyMemberCaregiverPhoneNumber = {
  __typename?: 'AgencyMemberCaregiverPhoneNumber';
  caregiverId: Scalars['CaregiverId']['output'];
  isSmsable: Scalars['Boolean']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type AgencyMemberCaregiverPhoneNumberConnection = {
  __typename?: 'AgencyMemberCaregiverPhoneNumberConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberCaregiverPhoneNumber>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberCaregiverStateCompliance = {
  __typename?: 'AgencyMemberCaregiverStateCompliance';
  caregiver: AgencyMemberCaregiver;
  caregiverId: Scalars['CaregiverId']['output'];
  issue: StateComplianceIssueType;
};

export type AgencyMemberCaregiverStateComplianceConnection = {
  __typename?: 'AgencyMemberCaregiverStateComplianceConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberCaregiverStateCompliance>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberCaregiverStateCompliance__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberCaregiverStateCompliance__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberCaregiverStateCompliance__OrderField {
  CaregiverId = 'caregiverId',
  Issue = 'issue'
}

export type AgencyMemberCaregiver_RelationFilter = {
  /** Filter based on "createdAt" field */
  createdAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "firstName" field */
  firstName?: InputMaybe<String_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<CaregiverId_Filter>;
  /** Filter based on "lastName" field */
  lastName?: InputMaybe<String_Filter>;
  nameSearch?: InputMaybe<Scalars['Instant']['input']>;
};

export type AgencyMemberCaregiver__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberCaregiver__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberCaregiver__OrderField {
  CreatedAt = 'createdAt',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName'
}

/** Filter result rows based on the value of a field */
export type AgencyMemberId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['AgencyMemberId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['AgencyMemberId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['AgencyMemberId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['AgencyMemberId']['input']>>;
};

export type AgencyMemberImportedVisit = {
  __typename?: 'AgencyMemberImportedVisit';
  caregiverId: Scalars['CaregiverId']['output'];
  endTimeLocal: Scalars['LocalDateTime']['output'];
  id: Scalars['ImportedVisitId']['output'];
  startTimeLocal: Scalars['LocalDateTime']['output'];
};

export type AgencyMemberImportedVisitConnection = {
  __typename?: 'AgencyMemberImportedVisitConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberImportedVisit>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberImportedVisit_RelationFilter = {
  /** Filter based on "caregiverId" field */
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']['input']>;
  /** Filter based on "endTimeLocal" field */
  endTimeLocal?: InputMaybe<LocalDateTime_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<ImportedVisitId_Filter>;
  /** Filter based on "startTimeLocal" field */
  startTimeLocal?: InputMaybe<LocalDateTime_Filter>;
};

export type AgencyMemberImportedVisit__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberImportedVisit__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberImportedVisit__OrderField {
  CaregiverId = 'caregiverId',
  EndTimeLocal = 'endTimeLocal',
  Id = 'id',
  StartTimeLocal = 'startTimeLocal'
}

export type AgencyMemberOffice = {
  __typename?: 'AgencyMemberOffice';
  active: Scalars['Boolean']['output'];
  addressText: Scalars['String']['output'];
  addressTimezone: Scalars['String']['output'];
  caregivers: CaregiverOfficeAssocConnection;
  id: Scalars['OfficeId']['output'];
  name: Scalars['String']['output'];
};


export type AgencyMemberOfficeCaregiversArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  office?: InputMaybe<AgencyMemberOffice_RelationFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AgencyMemberOfficeAssoc = {
  __typename?: 'AgencyMemberOfficeAssoc';
  agencyMember: AgencyMemberAgencyMember;
  office: AgencyMemberOffice;
};

export type AgencyMemberOfficeAssocConnection = {
  __typename?: 'AgencyMemberOfficeAssocConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberOfficeAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberOfficeAssoc__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberOfficeAssoc__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberOfficeAssoc__OrderField {
  OfficeId = 'officeId'
}

export type AgencyMemberOfficeConnection = {
  __typename?: 'AgencyMemberOfficeConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberOffice>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberOffice_RelationFilter = {
  /** Filter based on "id" field */
  id?: InputMaybe<OfficeId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
};

export type AgencyMemberOffice__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberOffice__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberOffice__OrderField {
  Id = 'id',
  Name = 'name'
}

export type AgencyMemberPatientLeadQualifications = {
  __typename?: 'AgencyMemberPatientLeadQualifications';
  disqualifiedAt?: Maybe<Scalars['Instant']['output']>;
  isQualified: Scalars['Boolean']['output'];
  patient: Patient;
  patientId: Scalars['PatientId']['output'];
  qualifiedAt?: Maybe<Scalars['Instant']['output']>;
  qualifiedReason?: Maybe<PatientQualifiedLeadReason>;
};

export type AgencyMemberPatientLeadQualificationsConnection = {
  __typename?: 'AgencyMemberPatientLeadQualificationsConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberPatientLeadQualifications>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberPatientLeadQualifications__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberPatientLeadQualifications__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberPatientLeadQualifications__OrderField {
  DisqualifiedAt = 'disqualifiedAt',
  IsQualified = 'isQualified',
  PatientId = 'patientId',
  QualifiedAt = 'qualifiedAt',
  QualifiedReason = 'qualifiedReason'
}

export type AgencyMemberPatientWebsiteVisitor = {
  __typename?: 'AgencyMemberPatientWebsiteVisitor';
  createdAt: Scalars['Instant']['output'];
  events: AgencyMemberPatientWebsiteVisitorEventConnection;
  id: Scalars['PatientWebsiteVisitorId']['output'];
  patient: Patient;
  patientId?: Maybe<Scalars['PatientId']['output']>;
  uuid: Scalars['String']['output'];
  visits: AgencyMemberPatientWebsiteVisitorVisitConnection;
};


export type AgencyMemberPatientWebsiteVisitorEventsArgs = {
  createdAt?: InputMaybe<Instant_Filter>;
  eventName?: InputMaybe<String_Filter>;
  eventType?: InputMaybe<String_Filter>;
  id?: InputMaybe<PatientWebsiteVisitorEventId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberPatientWebsiteVisitorEvent__Order>>>;
  visit?: InputMaybe<AgencyMemberPatientWebsiteVisitorVisit_RelationFilter>;
  visitId?: InputMaybe<PatientWebsiteVisitorVisitId_Filter>;
  visitor?: InputMaybe<AgencyMemberPatientWebsiteVisitor_RelationFilter>;
  websiteVisitorId?: InputMaybe<PatientWebsiteVisitorId_Filter>;
};


export type AgencyMemberPatientWebsiteVisitorVisitsArgs = {
  adContent?: InputMaybe<String_Filter>;
  adGroup?: InputMaybe<String_Filter>;
  assignedPhoneNumber?: InputMaybe<String_Filter>;
  campaign?: InputMaybe<String_Filter>;
  createdAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<PatientWebsiteVisitorVisitId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  medium?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberPatientWebsiteVisitorVisit__Order>>>;
  searchTerm?: InputMaybe<String_Filter>;
  source?: InputMaybe<String_Filter>;
  visitor?: InputMaybe<AgencyMemberPatientWebsiteVisitor_RelationFilter>;
  websiteVisitorId?: InputMaybe<PatientWebsiteVisitorId_Filter>;
};

export type AgencyMemberPatientWebsiteVisitorConnection = {
  __typename?: 'AgencyMemberPatientWebsiteVisitorConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberPatientWebsiteVisitor>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberPatientWebsiteVisitorEvent = {
  __typename?: 'AgencyMemberPatientWebsiteVisitorEvent';
  createdAt: Scalars['Instant']['output'];
  eventName: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['PatientWebsiteVisitorEventId']['output'];
  visit: AgencyMemberPatientWebsiteVisitorVisit;
  visitId: Scalars['PatientWebsiteVisitorVisitId']['output'];
  visitor: AgencyMemberPatientWebsiteVisitor;
  websiteVisitorId: Scalars['PatientWebsiteVisitorId']['output'];
};

export type AgencyMemberPatientWebsiteVisitorEventConnection = {
  __typename?: 'AgencyMemberPatientWebsiteVisitorEventConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberPatientWebsiteVisitorEvent>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberPatientWebsiteVisitorEvent__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberPatientWebsiteVisitorEvent__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberPatientWebsiteVisitorEvent__OrderField {
  CreatedAt = 'createdAt',
  EventName = 'eventName',
  EventType = 'eventType',
  Id = 'id',
  VisitId = 'visitId',
  WebsiteVisitorId = 'websiteVisitorId'
}

export type AgencyMemberPatientWebsiteVisitorVisit = {
  __typename?: 'AgencyMemberPatientWebsiteVisitorVisit';
  adContent?: Maybe<Scalars['String']['output']>;
  adGroup?: Maybe<Scalars['String']['output']>;
  assignedPhoneNumber?: Maybe<Scalars['String']['output']>;
  campaign?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Instant']['output'];
  events: AgencyMemberPatientWebsiteVisitorEventConnection;
  id: Scalars['PatientWebsiteVisitorVisitId']['output'];
  medium?: Maybe<Scalars['String']['output']>;
  searchTerm?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  visitor: AgencyMemberPatientWebsiteVisitor;
  websiteVisitorId: Scalars['PatientWebsiteVisitorId']['output'];
};


export type AgencyMemberPatientWebsiteVisitorVisitEventsArgs = {
  createdAt?: InputMaybe<Instant_Filter>;
  eventName?: InputMaybe<String_Filter>;
  eventType?: InputMaybe<String_Filter>;
  id?: InputMaybe<PatientWebsiteVisitorEventId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberPatientWebsiteVisitorEvent__Order>>>;
  visit?: InputMaybe<AgencyMemberPatientWebsiteVisitorVisit_RelationFilter>;
  visitId?: InputMaybe<PatientWebsiteVisitorVisitId_Filter>;
  visitor?: InputMaybe<AgencyMemberPatientWebsiteVisitor_RelationFilter>;
  websiteVisitorId?: InputMaybe<PatientWebsiteVisitorId_Filter>;
};

export type AgencyMemberPatientWebsiteVisitorVisitConnection = {
  __typename?: 'AgencyMemberPatientWebsiteVisitorVisitConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberPatientWebsiteVisitorVisit>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberPatientWebsiteVisitorVisit_RelationFilter = {
  /** Filter based on "adContent" field */
  adContent?: InputMaybe<String_Filter>;
  /** Filter based on "adGroup" field */
  adGroup?: InputMaybe<String_Filter>;
  /** Filter based on "assignedPhoneNumber" field */
  assignedPhoneNumber?: InputMaybe<String_Filter>;
  /** Filter based on "campaign" field */
  campaign?: InputMaybe<String_Filter>;
  /** Filter based on "createdAt" field */
  createdAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<PatientWebsiteVisitorVisitId_Filter>;
  /** Filter based on "medium" field */
  medium?: InputMaybe<String_Filter>;
  /** Filter based on "searchTerm" field */
  searchTerm?: InputMaybe<String_Filter>;
  /** Filter based on "source" field */
  source?: InputMaybe<String_Filter>;
  /** Filter based on "websiteVisitorId" field */
  websiteVisitorId?: InputMaybe<PatientWebsiteVisitorId_Filter>;
};

export type AgencyMemberPatientWebsiteVisitorVisit__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberPatientWebsiteVisitorVisit__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberPatientWebsiteVisitorVisit__OrderField {
  AdContent = 'adContent',
  AdGroup = 'adGroup',
  AssignedPhoneNumber = 'assignedPhoneNumber',
  Campaign = 'campaign',
  CreatedAt = 'createdAt',
  Id = 'id',
  Medium = 'medium',
  SearchTerm = 'searchTerm',
  Source = 'source',
  WebsiteVisitorId = 'websiteVisitorId'
}

export type AgencyMemberPatientWebsiteVisitor_RelationFilter = {
  /** Filter based on "createdAt" field */
  createdAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<PatientWebsiteVisitorId_Filter>;
  /** Filter based on "patientId" field */
  patientId?: InputMaybe<PatientId_Filter>;
  /** Filter based on "uuid" field */
  uuid?: InputMaybe<String_Filter>;
};

export type AgencyMemberPatientWebsiteVisitor__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberPatientWebsiteVisitor__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberPatientWebsiteVisitor__OrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  PatientId = 'patientId',
  Uuid = 'uuid'
}

export type AgencyMemberVisitBroadcast = {
  __typename?: 'AgencyMemberVisitBroadcast';
  broadcastedTo: VisitBroadcastBroadcastedToConnection;
  canceledAt?: Maybe<Scalars['Instant']['output']>;
  createdAt: Scalars['Instant']['output'];
  endTimeLocal: Scalars['LocalDateTime']['output'];
  endTimeUTC: Scalars['Instant']['output'];
  engagements: VisitBroadcastCaregiverEngagementConnection;
  id: Scalars['VisitBroadcastId']['output'];
  notBroadcastedTo: VisitBroadcastNotBroadcastedToConnection;
  radiusMeters?: Maybe<Scalars['Float']['output']>;
  startTimeLocal: Scalars['LocalDateTime']['output'];
  startTimeUTC: Scalars['Instant']['output'];
  visitInstances: VisitBroadcastAssocConnection;
};


export type AgencyMemberVisitBroadcastBroadcastedToArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<VisitBroadcastBroadcastedTo__Order>>>;
  visitBroadcast?: InputMaybe<AgencyMemberVisitBroadcast_RelationFilter>;
};


export type AgencyMemberVisitBroadcastEngagementsArgs = {
  acceptedTime?: InputMaybe<Instant_Filter>;
  active?: InputMaybe<Boolean_Filter>;
  cancelTime?: InputMaybe<Instant_Filter>;
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<CaregiverVisitEngagementId_Filter>;
  isRequestActive?: InputMaybe<Boolean_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  moreDetailsViewedAt?: InputMaybe<Instant_Filter>;
  notInterestedReason?: InputMaybe<String_Filter>;
  notInterestedTime?: InputMaybe<Instant_Filter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<VisitBroadcastCaregiverEngagement__Order>>>;
  viewedAt?: InputMaybe<Instant_Filter>;
  visitBroadcast?: InputMaybe<AgencyMemberVisitBroadcast_RelationFilter>;
  visitBroadcastId?: InputMaybe<VisitBroadcastId_Filter>;
};


export type AgencyMemberVisitBroadcastNotBroadcastedToArgs = {
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  caregiverMarkedNotInterested?: InputMaybe<Boolean_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<VisitBroadcastNotBroadcastedTo__Order>>>;
};


export type AgencyMemberVisitBroadcastVisitInstancesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  visitBroadcast?: InputMaybe<AgencyMemberVisitBroadcast_RelationFilter>;
  visitInstances?: InputMaybe<AgencyMemberVisitInstance_RelationFilter>;
};

export type AgencyMemberVisitBroadcastConnection = {
  __typename?: 'AgencyMemberVisitBroadcastConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberVisitBroadcast>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberVisitBroadcast_RelationFilter = {
  /** Filter based on "canceledAt" field */
  canceledAt?: InputMaybe<Instant_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']['input']>;
  /** Filter based on "createdAt" field */
  createdAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<VisitBroadcastId_Filter>;
};

export type AgencyMemberVisitBroadcast__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberVisitBroadcast__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberVisitBroadcast__OrderField {
  CanceledAt = 'canceledAt',
  CreatedAt = 'createdAt',
  EndTimeLocal = 'endTimeLocal',
  EndTimeUtc = 'endTimeUTC',
  Id = 'id',
  StartTimeLocal = 'startTimeLocal',
  StartTimeUtc = 'startTimeUTC'
}

export type AgencyMemberVisitInstance = {
  __typename?: 'AgencyMemberVisitInstance';
  addressTimezone: Scalars['String']['output'];
  authorizationAllocations: VisitInstanceAuthorizationAllocationConnection;
  caregiver?: Maybe<AgencyMemberCaregiver>;
  caregiverId?: Maybe<Scalars['CaregiverId']['output']>;
  endTimeLocal: Scalars['PermissionControlledField_LocalDateTime']['output'];
  endTimeUTC: Scalars['PermissionControlledField_Instant']['output'];
  id: Scalars['VisitInstanceId']['output'];
  isBilled: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  patient: Patient;
  patientId: Scalars['PatientId']['output'];
  startTimeLocal: Scalars['PermissionControlledField_LocalDateTime']['output'];
  startTimeUTC: Scalars['PermissionControlledField_Instant']['output'];
  visitBroadcasts: VisitBroadcastAssocConnection;
  visit_date: Scalars['PermissionControlledField_LocalDate']['output'];
  visit_day_of_week: Scalars['PermissionControlledField_DayOfWeek']['output'];
};


export type AgencyMemberVisitInstanceAuthorizationAllocationsArgs = {
  authorization?: InputMaybe<PatientAuthorization_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  visitInstance?: InputMaybe<AgencyMemberVisitInstance_RelationFilter>;
};


export type AgencyMemberVisitInstanceVisitBroadcastsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  visitBroadcast?: InputMaybe<AgencyMemberVisitBroadcast_RelationFilter>;
  visitInstances?: InputMaybe<AgencyMemberVisitInstance_RelationFilter>;
};

export type AgencyMemberVisitInstanceConnection = {
  __typename?: 'AgencyMemberVisitInstanceConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberVisitInstance>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberVisitInstance_RelationFilter = {
  /** Filter based on "caregiverId" field */
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']['input']>;
  /** Filter based on "id" field */
  id?: InputMaybe<VisitInstanceId_Filter>;
  /** Filter based on "patientId" field */
  patientId?: InputMaybe<PatientId_Filter>;
};

export type AgencyMemberVisitInstance__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberVisitInstance__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberVisitInstance__OrderField {
  CaregiverId = 'caregiverId',
  Id = 'id',
  PatientId = 'patientId'
}

export type AgencyMemberWorkflowDefinition = {
  __typename?: 'AgencyMemberWorkflowDefinition';
  children: Scalars['String']['output'];
  correlationKey: Scalars['WorkflowDefinitionCorrelationKey']['output'];
  createHumanTaskOnFailure: Scalars['Boolean']['output'];
  createdAt: Scalars['Instant']['output'];
  description: Scalars['String']['output'];
  id: Scalars['WorkflowDefinitionId']['output'];
  input: Scalars['WorkflowInputs']['output'];
  inputHidden: Scalars['String']['output'];
  name: Scalars['String']['output'];
  output: Scalars['String']['output'];
  owner: AgencyMemberAgencyMember;
  ownerId: Scalars['AgencyMemberId']['output'];
  priority: Scalars['Int']['output'];
  published: Scalars['Boolean']['output'];
  severity: Scalars['String']['output'];
  timeout: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  versions: AgencyMemberWorkflowDefinitionConnection;
  workflowInstances: AgencyMemberWorkflowInstanceConnection;
};


export type AgencyMemberWorkflowDefinitionVersionsArgs = {
  correlationKey?: InputMaybe<WorkflowDefinitionCorrelationKey_Filter>;
  createHumanTaskOnFailure?: InputMaybe<Boolean_Filter>;
  createdAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<WorkflowDefinitionId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowDefinition__Order>>>;
  owner?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  ownerId?: InputMaybe<AgencyMemberId_Filter>;
  priority?: InputMaybe<Int_Filter>;
  published?: InputMaybe<Boolean_Filter>;
  severity?: InputMaybe<String_Filter>;
  timeout?: InputMaybe<Int_Filter>;
  version?: InputMaybe<Int_Filter>;
};


export type AgencyMemberWorkflowDefinitionWorkflowInstancesArgs = {
  canceledAt?: InputMaybe<Instant_Filter>;
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']['input']>>;
  completedAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<WorkflowInstanceId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowInstance__Order>>>;
  patientIds?: InputMaybe<Array<Scalars['PatientId']['input']>>;
  startedAt?: InputMaybe<Instant_Filter>;
  startedAtFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  startedAtTo?: InputMaybe<Scalars['LocalDate']['input']>;
  status?: InputMaybe<String_Filter>;
  success?: InputMaybe<Boolean_Filter>;
  workflowDefinition?: InputMaybe<AgencyMemberWorkflowDefinition_RelationFilter>;
  workflowDefinitionCorrelationKey?: InputMaybe<WorkflowDefinitionCorrelationKey_Filter>;
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
  workflowManualStartedBy?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  workflowManualStartedById?: InputMaybe<AgencyMemberId_Filter>;
  workflowTriggerId?: InputMaybe<WorkflowDefinitionTriggerId_Filter>;
  workflowTriggerTaskInstanceId?: InputMaybe<WorkflowTaskInstanceId_Filter>;
  workflowTriggerType?: InputMaybe<String_Filter>;
};

export type AgencyMemberWorkflowDefinitionConnection = {
  __typename?: 'AgencyMemberWorkflowDefinitionConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberWorkflowDefinition>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberWorkflowDefinition_RelationFilter = {
  /** Filter based on "correlationKey" field */
  correlationKey?: InputMaybe<WorkflowDefinitionCorrelationKey_Filter>;
  /** Filter based on "createHumanTaskOnFailure" field */
  createHumanTaskOnFailure?: InputMaybe<Boolean_Filter>;
  /** Filter based on "createdAt" field */
  createdAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<WorkflowDefinitionId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
  /** Filter based on "ownerId" field */
  ownerId?: InputMaybe<AgencyMemberId_Filter>;
  /** Filter based on "priority" field */
  priority?: InputMaybe<Int_Filter>;
  /** Filter based on "published" field */
  published?: InputMaybe<Boolean_Filter>;
  /** Filter based on "severity" field */
  severity?: InputMaybe<String_Filter>;
  /** Filter based on "timeout" field */
  timeout?: InputMaybe<Int_Filter>;
  /** Filter based on "version" field */
  version?: InputMaybe<Int_Filter>;
};

export type AgencyMemberWorkflowDefinition__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberWorkflowDefinition__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberWorkflowDefinition__OrderField {
  CorrelationKey = 'correlationKey',
  CreateHumanTaskOnFailure = 'createHumanTaskOnFailure',
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  OwnerId = 'ownerId',
  Priority = 'priority',
  Published = 'published',
  Severity = 'severity',
  Timeout = 'timeout',
  Version = 'version'
}

export type AgencyMemberWorkflowInstance = {
  __typename?: 'AgencyMemberWorkflowInstance';
  canceledAt?: Maybe<Scalars['Instant']['output']>;
  completedAt?: Maybe<Scalars['Instant']['output']>;
  id: Scalars['WorkflowInstanceId']['output'];
  input: Scalars['WorkflowExecutionValueObject']['output'];
  origin: Scalars['WorkflowInstanceOrigin']['output'];
  output?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['Instant']['output'];
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  workflowDefinition: AgencyMemberWorkflowDefinition;
  workflowDefinitionCorrelationKey: Scalars['WorkflowDefinitionCorrelationKey']['output'];
  workflowDefinitionId: Scalars['WorkflowDefinitionId']['output'];
  workflowManualStartedBy: AgencyMemberAgencyMember;
  workflowManualStartedById?: Maybe<Scalars['AgencyMemberId']['output']>;
  workflowManualTriggerName?: Maybe<Scalars['String']['output']>;
  workflowTriggerEventTable?: Maybe<Scalars['String']['output']>;
  workflowTriggerEventType?: Maybe<Scalars['String']['output']>;
  workflowTriggerId?: Maybe<Scalars['WorkflowDefinitionTriggerId']['output']>;
  workflowTriggerReportKey?: Maybe<Scalars['String']['output']>;
  workflowTriggerTaskInstanceId?: Maybe<Scalars['WorkflowTaskInstanceId']['output']>;
  workflowTriggerType: Scalars['String']['output'];
  workflowTriggeringWorkflowId?: Maybe<Scalars['WorkflowInstanceId']['output']>;
  workflowTriggeringWorkflowName?: Maybe<Scalars['String']['output']>;
};

export type AgencyMemberWorkflowInstanceConnection = {
  __typename?: 'AgencyMemberWorkflowInstanceConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberWorkflowInstance>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberWorkflowInstanceInputEntities = {
  __typename?: 'AgencyMemberWorkflowInstanceInputEntities';
  entity: Scalars['String']['output'];
  key: Scalars['String']['output'];
  value: Scalars['Any']['output'];
};

export type AgencyMemberWorkflowInstanceInputEntitiesConnection = {
  __typename?: 'AgencyMemberWorkflowInstanceInputEntitiesConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberWorkflowInstanceInputEntities>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberWorkflowInstance_RelationFilter = {
  /** Filter based on "canceledAt" field */
  canceledAt?: InputMaybe<Instant_Filter>;
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']['input']>>;
  /** Filter based on "completedAt" field */
  completedAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<WorkflowInstanceId_Filter>;
  patientIds?: InputMaybe<Array<Scalars['PatientId']['input']>>;
  /** Filter based on "startedAt" field */
  startedAt?: InputMaybe<Instant_Filter>;
  startedAtFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  startedAtTo?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Filter based on "status" field */
  status?: InputMaybe<String_Filter>;
  /** Filter based on "success" field */
  success?: InputMaybe<Boolean_Filter>;
  /** Filter based on "workflowDefinitionCorrelationKey" field */
  workflowDefinitionCorrelationKey?: InputMaybe<WorkflowDefinitionCorrelationKey_Filter>;
  /** Filter based on "workflowDefinitionId" field */
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
  /** Filter based on "workflowManualStartedById" field */
  workflowManualStartedById?: InputMaybe<AgencyMemberId_Filter>;
  /** Filter based on "workflowTriggerId" field */
  workflowTriggerId?: InputMaybe<WorkflowDefinitionTriggerId_Filter>;
  /** Filter based on "workflowTriggerTaskInstanceId" field */
  workflowTriggerTaskInstanceId?: InputMaybe<WorkflowTaskInstanceId_Filter>;
  /** Filter based on "workflowTriggerType" field */
  workflowTriggerType?: InputMaybe<String_Filter>;
};

export type AgencyMemberWorkflowInstance__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberWorkflowInstance__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberWorkflowInstance__OrderField {
  CanceledAt = 'canceledAt',
  CompletedAt = 'completedAt',
  Id = 'id',
  StartedAt = 'startedAt',
  Status = 'status',
  Success = 'success',
  WorkflowDefinitionCorrelationKey = 'workflowDefinitionCorrelationKey',
  WorkflowDefinitionId = 'workflowDefinitionId',
  WorkflowManualStartedById = 'workflowManualStartedById',
  WorkflowTriggerId = 'workflowTriggerId',
  WorkflowTriggerTaskInstanceId = 'workflowTriggerTaskInstanceId',
  WorkflowTriggerType = 'workflowTriggerType'
}

export type AgencyMemberWorkflowTag = {
  __typename?: 'AgencyMemberWorkflowTag';
  id: Scalars['WorkflowTagId']['output'];
  input: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AgencyMemberWorkflowTagConnection = {
  __typename?: 'AgencyMemberWorkflowTagConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberWorkflowTag>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberWorkflowTag_RelationFilter = {
  /** Filter based on "id" field */
  id?: InputMaybe<WorkflowTagId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
};

export type AgencyMemberWorkflowTag__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberWorkflowTag__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberWorkflowTag__OrderField {
  Id = 'id',
  Name = 'name'
}

export type AgencyMemberWorkflowTaskDefinition = {
  __typename?: 'AgencyMemberWorkflowTaskDefinition';
  assignmentTimeoutSeconds?: Maybe<Scalars['Int']['output']>;
  children?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  error_handlers?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  workflowDefinition: AgencyMemberWorkflowDefinition;
  workflowDefinitionId: Scalars['WorkflowDefinitionId']['output'];
};

export type AgencyMemberWorkflowTaskDefinitionConnection = {
  __typename?: 'AgencyMemberWorkflowTaskDefinitionConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberWorkflowTaskDefinition>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberWorkflowTaskDefinition_RelationFilter = {
  /** Filter based on "id" field */
  id?: InputMaybe<String_Filter>;
  /** Filter based on "mandatory" field */
  mandatory?: InputMaybe<Boolean_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
  /** Filter based on "priority" field */
  priority?: InputMaybe<Int_Filter>;
  /** Filter based on "severity" field */
  severity?: InputMaybe<String_Filter>;
  /** Filter based on "type" field */
  type?: InputMaybe<String_Filter>;
  /** Filter based on "workflowDefinitionId" field */
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
};

export type AgencyMemberWorkflowTaskDefinition__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberWorkflowTaskDefinition__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberWorkflowTaskDefinition__OrderField {
  Id = 'id',
  Mandatory = 'mandatory',
  Name = 'name',
  Priority = 'priority',
  Severity = 'severity',
  Type = 'type',
  WorkflowDefinitionId = 'workflowDefinitionId'
}

export type AgencyMemberWorkflowTaskInstance = {
  __typename?: 'AgencyMemberWorkflowTaskInstance';
  clusterId?: Maybe<Scalars['WorkflowTaskClusterId']['output']>;
  clusterValue?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['Instant']['output']>;
  completedBy?: Maybe<AgencyMemberAgencyMember>;
  completedById?: Maybe<Scalars['AgencyMemberId']['output']>;
  createdAt: Scalars['Instant']['output'];
  id: Scalars['WorkflowTaskInstanceId']['output'];
  input: AgencyMemberWorkflowTaskInstanceInputConnection;
  priority?: Maybe<Scalars['Int']['output']>;
  retryCount: Scalars['Int']['output'];
  severity?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  systemTaskId?: Maybe<Scalars['String']['output']>;
  systemTaskVersion?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  workflowDefinitionId: Scalars['WorkflowDefinitionId']['output'];
  workflowInstance: AgencyMemberWorkflowInstance;
  workflowInstanceId: Scalars['WorkflowInstanceId']['output'];
  workflowTaskDefinition?: Maybe<AgencyMemberWorkflowTaskDefinition>;
  workflowTaskDefinitionId: Scalars['String']['output'];
  workflowTaskInstanceTags: AgencyMemberWorkflowTaskInstanceTagConnection;
};


export type AgencyMemberWorkflowTaskInstanceInputArgs = {
  entity?: InputMaybe<String_Filter>;
  fieldName?: InputMaybe<String_Filter>;
  isArray?: InputMaybe<Boolean_Filter>;
  isNullable?: InputMaybe<Boolean_Filter>;
  isOptional?: InputMaybe<Boolean_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowTaskInstanceInput__Order>>>;
  type?: InputMaybe<String_Filter>;
  value?: InputMaybe<String_Filter>;
  valueOrd?: InputMaybe<Int_Filter>;
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
  workflowInstanceId?: InputMaybe<WorkflowInstanceId_Filter>;
  workflowTaskDefinitionId?: InputMaybe<String_Filter>;
  workflowTaskInstance?: InputMaybe<AgencyMemberWorkflowTaskInstance_RelationFilter>;
  workflowTaskInstanceId?: InputMaybe<WorkflowTaskInstanceId_Filter>;
};


export type AgencyMemberWorkflowTaskInstanceWorkflowTaskInstanceTagsArgs = {
  createdAt?: InputMaybe<Instant_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowTaskInstanceTag__Order>>>;
  tagId?: InputMaybe<WorkflowTagId_Filter>;
  tagValue?: InputMaybe<String_Filter>;
  workflowTagDefinition?: InputMaybe<AgencyMemberWorkflowTag_RelationFilter>;
  workflowTaskInstance?: InputMaybe<AgencyMemberWorkflowTaskInstance_RelationFilter>;
  workflowTaskInstanceId?: InputMaybe<WorkflowTaskInstanceId_Filter>;
};

export type AgencyMemberWorkflowTaskInstanceConnection = {
  __typename?: 'AgencyMemberWorkflowTaskInstanceConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberWorkflowTaskInstance>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberWorkflowTaskInstanceInput = {
  __typename?: 'AgencyMemberWorkflowTaskInstanceInput';
  entity?: Maybe<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
  isArray: Scalars['Boolean']['output'];
  isNullable: Scalars['Boolean']['output'];
  isOptional: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
  valueOrd?: Maybe<Scalars['Int']['output']>;
  workflowDefinitionId: Scalars['WorkflowDefinitionId']['output'];
  workflowInstanceId: Scalars['WorkflowInstanceId']['output'];
  workflowTaskDefinitionId: Scalars['String']['output'];
  workflowTaskInstance: AgencyMemberWorkflowTaskInstance;
  workflowTaskInstanceId: Scalars['WorkflowTaskInstanceId']['output'];
};

export type AgencyMemberWorkflowTaskInstanceInputConnection = {
  __typename?: 'AgencyMemberWorkflowTaskInstanceInputConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberWorkflowTaskInstanceInput>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberWorkflowTaskInstanceInput__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberWorkflowTaskInstanceInput__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberWorkflowTaskInstanceInput__OrderField {
  Entity = 'entity',
  FieldName = 'fieldName',
  IsArray = 'isArray',
  IsNullable = 'isNullable',
  IsOptional = 'isOptional',
  Type = 'type',
  Value = 'value',
  ValueOrd = 'valueOrd',
  WorkflowDefinitionId = 'workflowDefinitionId',
  WorkflowInstanceId = 'workflowInstanceId',
  WorkflowTaskDefinitionId = 'workflowTaskDefinitionId',
  WorkflowTaskInstanceId = 'workflowTaskInstanceId'
}

export type AgencyMemberWorkflowTaskInstanceTag = {
  __typename?: 'AgencyMemberWorkflowTaskInstanceTag';
  createdAt: Scalars['Instant']['output'];
  tagId: Scalars['WorkflowTagId']['output'];
  tagValue: Scalars['String']['output'];
  workflowTagDefinition: AgencyMemberWorkflowTag;
  workflowTaskInstance: AgencyMemberWorkflowTaskInstance;
  workflowTaskInstanceId: Scalars['WorkflowTaskInstanceId']['output'];
};

export type AgencyMemberWorkflowTaskInstanceTagConnection = {
  __typename?: 'AgencyMemberWorkflowTaskInstanceTagConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberWorkflowTaskInstanceTag>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberWorkflowTaskInstanceTag__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberWorkflowTaskInstanceTag__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberWorkflowTaskInstanceTag__OrderField {
  CreatedAt = 'createdAt',
  TagId = 'tagId',
  TagValue = 'tagValue',
  WorkflowTaskInstanceId = 'workflowTaskInstanceId'
}

export type AgencyMemberWorkflowTaskInstance_RelationFilter = {
  /** Filter based on "clusterId" field */
  clusterId?: InputMaybe<WorkflowTaskClusterId_Filter>;
  /** Filter based on "clusterValue" field */
  clusterValue?: InputMaybe<String_Filter>;
  /** Filter based on "completedAt" field */
  completedAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "completedById" field */
  completedById?: InputMaybe<AgencyMemberId_Filter>;
  /** Filter based on "createdAt" field */
  createdAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<WorkflowTaskInstanceId_Filter>;
  /** Filter based on "priority" field */
  priority?: InputMaybe<Int_Filter>;
  /** Filter based on "retryCount" field */
  retryCount?: InputMaybe<Int_Filter>;
  /** Filter based on "severity" field */
  severity?: InputMaybe<String_Filter>;
  /** Filter based on "success" field */
  success?: InputMaybe<Boolean_Filter>;
  /** Filter based on "systemTaskId" field */
  systemTaskId?: InputMaybe<String_Filter>;
  /** Filter based on "systemTaskVersion" field */
  systemTaskVersion?: InputMaybe<Int_Filter>;
  /** Filter based on "type" field */
  type?: InputMaybe<String_Filter>;
  /** Filter based on "workflowDefinitionId" field */
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
  /** Filter based on "workflowInstanceId" field */
  workflowInstanceId?: InputMaybe<WorkflowInstanceId_Filter>;
  /** Filter based on "workflowTaskDefinitionId" field */
  workflowTaskDefinitionId?: InputMaybe<String_Filter>;
};

export type AgencyMemberWorkflowTaskInstance__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberWorkflowTaskInstance__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberWorkflowTaskInstance__OrderField {
  ClusterId = 'clusterId',
  ClusterValue = 'clusterValue',
  CompletedAt = 'completedAt',
  CompletedById = 'completedById',
  CreatedAt = 'createdAt',
  Id = 'id',
  Priority = 'priority',
  RetryCount = 'retryCount',
  Severity = 'severity',
  Success = 'success',
  SystemTaskId = 'systemTaskId',
  SystemTaskVersion = 'systemTaskVersion',
  Type = 'type',
  WorkflowDefinitionId = 'workflowDefinitionId',
  WorkflowInstanceId = 'workflowInstanceId',
  WorkflowTaskDefinitionId = 'workflowTaskDefinitionId'
}

export type AgencyMemberWorkflowTaskSkill = {
  __typename?: 'AgencyMemberWorkflowTaskSkill';
  id: Scalars['WorkflowSkillId']['output'];
  workflowTaskInstanceId: Scalars['WorkflowTaskInstanceId']['output'];
};

export type AgencyMemberWorkflowTaskSkillConnection = {
  __typename?: 'AgencyMemberWorkflowTaskSkillConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyMemberWorkflowTaskSkill>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyMemberWorkflowTaskSkill__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyMemberWorkflowTaskSkill__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyMemberWorkflowTaskSkill__OrderField {
  Id = 'id',
  WorkflowTaskInstanceId = 'workflowTaskInstanceId'
}

/** Filter result rows based on the value of a field */
export type AgencyPhonebookContactId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['AgencyPhonebookContactId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['AgencyPhonebookContactId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['AgencyPhonebookContactId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['AgencyPhonebookContactId']['input']>>;
};

export type AgencyTeam = {
  __typename?: 'AgencyTeam';
  active: Scalars['Boolean']['output'];
  agencyMembers: AgencyTeamAgencyMemberAssocConnection;
  id: Scalars['AgencyTeamId']['output'];
  name: Scalars['String']['output'];
  teamLeader: AgencyMemberAgencyMember;
  teamLeaderId?: Maybe<Scalars['AgencyMemberId']['output']>;
};


export type AgencyTeamAgencyMembersArgs = {
  agencyMember?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  agencyTeam?: InputMaybe<AgencyTeam_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AgencyTeamAgencyMemberAssoc = {
  __typename?: 'AgencyTeamAgencyMemberAssoc';
  agencyMember: AgencyMemberAgencyMember;
  agencyMemberId: Scalars['AgencyMemberId']['output'];
  agencyTeam: AgencyTeam;
  agencyTeamId: Scalars['AgencyTeamId']['output'];
};

export type AgencyTeamAgencyMemberAssocConnection = {
  __typename?: 'AgencyTeamAgencyMemberAssocConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyTeamAgencyMemberAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AgencyTeamConnection = {
  __typename?: 'AgencyTeamConnection';
  /** The nodes that match the query */
  nodes: Array<AgencyTeam>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

/** Filter result rows based on the value of a field */
export type AgencyTeamId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['AgencyTeamId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['AgencyTeamId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['AgencyTeamId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['AgencyTeamId']['input']>>;
};

export type AgencyTeam_RelationFilter = {
  /** Filter based on "active" field */
  active?: InputMaybe<Boolean_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<AgencyTeamId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
};

export type AgencyTeam__Order = {
  /** Field to order by */
  field?: InputMaybe<AgencyTeam__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AgencyTeam__OrderField {
  Active = 'active',
  Id = 'id',
  Name = 'name'
}

/** Filter result rows based on the value of a field */
export type AuthorizationId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['AuthorizationId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['AuthorizationId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['AuthorizationId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['AuthorizationId']['input']>>;
};

export type AuthorizedPatientWithoutVisitsView = {
  __typename?: 'AuthorizedPatientWithoutVisitsView';
  patient: Patient;
  patientAuthorization: PatientAuthorization;
  patientAuthorizationId: Scalars['AuthorizationId']['output'];
  patientId: Scalars['PatientId']['output'];
};

export type AuthorizedPatientWithoutVisitsViewConnection = {
  __typename?: 'AuthorizedPatientWithoutVisitsViewConnection';
  /** The nodes that match the query */
  nodes: Array<AuthorizedPatientWithoutVisitsView>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type AuthorizedPatientWithoutVisitsView__Order = {
  /** Field to order by */
  field?: InputMaybe<AuthorizedPatientWithoutVisitsView__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum AuthorizedPatientWithoutVisitsView__OrderField {
  EndDate = 'endDate',
  PatientAuthorizationId = 'patientAuthorizationId',
  PatientId = 'patientId',
  StartDate = 'startDate'
}

/** Filter result rows based on the value of a field */
export type Boolean_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Filter result rows based on the value of a field */
export type CaregiverId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['CaregiverId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['CaregiverId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['CaregiverId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['CaregiverId']['input']>>;
};

export type CaregiverOfficeAssoc = {
  __typename?: 'CaregiverOfficeAssoc';
  caregiver: AgencyMemberCaregiver;
  caregiverId: Scalars['CaregiverId']['output'];
  office: AgencyMemberOffice;
  officeId: Scalars['OfficeId']['output'];
};

export type CaregiverOfficeAssocConnection = {
  __typename?: 'CaregiverOfficeAssocConnection';
  /** The nodes that match the query */
  nodes: Array<CaregiverOfficeAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

/** Filter result rows based on the value of a field */
export type CaregiverVisitEngagementId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['CaregiverVisitEngagementId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['CaregiverVisitEngagementId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['CaregiverVisitEngagementId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['CaregiverVisitEngagementId']['input']>>;
};

export type CommCenterLabel = {
  __typename?: 'CommCenterLabel';
  _priority: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  assignedTeam: CommCenterTeam;
  assignedTeamId: Scalars['CommCenterTeamId']['output'];
  code?: Maybe<Scalars['String']['output']>;
  displayToAgencyMember: Scalars['Boolean']['output'];
  displayToCaregiver: Scalars['Boolean']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['CommCenterLabelId']['output'];
  messageActionId?: Maybe<Scalars['CommCenterMessageActionId']['output']>;
  name: Scalars['String']['output'];
  parent?: Maybe<CommCenterLabel>;
  parentId?: Maybe<Scalars['CommCenterLabelId']['output']>;
  priority: CommCenterLabelPriority;
  timeToResolve: Scalars['Int']['output'];
};

/** Filter result rows based on the value of a field */
export type CommCenterLabelId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['CommCenterLabelId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['CommCenterLabelId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['CommCenterLabelId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['CommCenterLabelId']['input']>>;
};

export enum CommCenterLabelPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type CommCenterLabel_RelationFilter = {
  /** Filter based on "_priority" field */
  _priority?: InputMaybe<String_Filter>;
  /** Filter based on "active" field */
  active?: InputMaybe<Boolean_Filter>;
  /** Filter based on "assignedTeamId" field */
  assignedTeamId?: InputMaybe<CommCenterTeamId_Filter>;
  /** Filter based on "code" field */
  code?: InputMaybe<String_Filter>;
  /** Filter based on "displayToAgencyMember" field */
  displayToAgencyMember?: InputMaybe<Boolean_Filter>;
  /** Filter based on "displayToCaregiver" field */
  displayToCaregiver?: InputMaybe<Boolean_Filter>;
  /** Filter based on "iconUrl" field */
  iconUrl?: InputMaybe<String_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<CommCenterLabelId_Filter>;
  /** Filter based on "messageActionId" field */
  messageActionId?: InputMaybe<CommCenterMessageActionId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
  /** Filter based on "parentId" field */
  parentId?: InputMaybe<CommCenterLabelId_Filter>;
  priority?: InputMaybe<Array<CommCenterLabelPriority>>;
  /** Filter based on "timeToResolve" field */
  timeToResolve?: InputMaybe<Int_Filter>;
};

/** Filter result rows based on the value of a field */
export type CommCenterMessageActionId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['CommCenterMessageActionId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['CommCenterMessageActionId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['CommCenterMessageActionId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['CommCenterMessageActionId']['input']>>;
};

export type CommCenterTeam = {
  __typename?: 'CommCenterTeam';
  active: Scalars['Boolean']['output'];
  id: Scalars['CommCenterTeamId']['output'];
  name: Scalars['String']['output'];
};

/** Filter result rows based on the value of a field */
export type CommCenterTeamId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['CommCenterTeamId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['CommCenterTeamId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['CommCenterTeamId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['CommCenterTeamId']['input']>>;
};

export type CommCenterTeam_RelationFilter = {
  /** Filter based on "active" field */
  active?: InputMaybe<Boolean_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<CommCenterTeamId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
};

export type CommCenterTicket = {
  __typename?: 'CommCenterTicket';
  _priority: Scalars['String']['output'];
  _source: Scalars['String']['output'];
  _topic: Scalars['String']['output'];
  caregiver?: Maybe<AgencyMemberCaregiver>;
  caregiverId?: Maybe<Scalars['CaregiverId']['output']>;
  createdAt: Scalars['Instant']['output'];
  createdBy: Scalars['UserId']['output'];
  createdBySystem: Scalars['Boolean']['output'];
  enableAgencyResponse: Scalars['Boolean']['output'];
  id: Scalars['CommCenterTicketId']['output'];
  label: CommCenterLabel;
  labelId: Scalars['CommCenterLabelId']['output'];
  patient?: Maybe<Patient>;
  patientId?: Maybe<Scalars['PatientId']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phonebookContact?: Maybe<PhonebookContact>;
  phonebookContactId?: Maybe<Scalars['AgencyPhonebookContactId']['output']>;
  priority: CommCenterLabelPriority;
  relatedVisitBroadcastId?: Maybe<Scalars['VisitBroadcastId']['output']>;
  relatedVisitInstanceId?: Maybe<Scalars['VisitInstanceId']['output']>;
  source: CommCenterTicketSource;
  team: CommCenterTeam;
  teamId: Scalars['CommCenterTeamId']['output'];
  topic: CommCenterTicketTopic;
  unreadCount: Scalars['Int']['output'];
  visitBroadcast?: Maybe<AgencyMemberVisitBroadcast>;
  visitInstance?: Maybe<AgencyMemberVisitInstance>;
};

export type CommCenterTicketConnection = {
  __typename?: 'CommCenterTicketConnection';
  /** The nodes that match the query */
  nodes: Array<CommCenterTicket>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

/** Filter result rows based on the value of a field */
export type CommCenterTicketId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['CommCenterTicketId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['CommCenterTicketId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['CommCenterTicketId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['CommCenterTicketId']['input']>>;
};

export enum CommCenterTicketSource {
  Email = 'EMAIL',
  Manual = 'MANUAL',
  MobileChat = 'MOBILE_CHAT',
  PhoneCall = 'PHONE_CALL',
  SmsConversation = 'SMS_CONVERSATION',
  SystemTrigger = 'SYSTEM_TRIGGER'
}

export enum CommCenterTicketTopic {
  BotAgent = 'BotAgent',
  Caregiver = 'Caregiver',
  NotIdentifiedEmailEntity = 'NotIdentifiedEmailEntity',
  NotIdentifiedPhoneNumber = 'NotIdentifiedPhoneNumber',
  Patient = 'Patient',
  PhonebookContact = 'PhonebookContact'
}

export type CommCenterTicket_RelationFilter = {
  /** Filter based on "_priority" field */
  _priority?: InputMaybe<String_Filter>;
  /** Filter based on "_source" field */
  _source?: InputMaybe<String_Filter>;
  /** Filter based on "_topic" field */
  _topic?: InputMaybe<String_Filter>;
  /** Filter based on "caregiverId" field */
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  /** Filter based on "createdAt" field */
  createdAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "createdBy" field */
  createdBy?: InputMaybe<UserId_Filter>;
  /** Filter based on "createdBySystem" field */
  createdBySystem?: InputMaybe<Boolean_Filter>;
  /** Filter based on "enableAgencyResponse" field */
  enableAgencyResponse?: InputMaybe<Boolean_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<CommCenterTicketId_Filter>;
  /** Filter based on "labelId" field */
  labelId?: InputMaybe<CommCenterLabelId_Filter>;
  /** Filter based on "patientId" field */
  patientId?: InputMaybe<PatientId_Filter>;
  /** Filter based on "phoneNumber" field */
  phoneNumber?: InputMaybe<String_Filter>;
  /** Filter based on "phonebookContactId" field */
  phonebookContactId?: InputMaybe<AgencyPhonebookContactId_Filter>;
  priority?: InputMaybe<Array<CommCenterLabelPriority>>;
  /** Filter based on "relatedVisitBroadcastId" field */
  relatedVisitBroadcastId?: InputMaybe<VisitBroadcastId_Filter>;
  /** Filter based on "relatedVisitInstanceId" field */
  relatedVisitInstanceId?: InputMaybe<VisitInstanceId_Filter>;
  source?: InputMaybe<Array<CommCenterTicketSource>>;
  /** Filter based on "teamId" field */
  teamId?: InputMaybe<CommCenterTeamId_Filter>;
  topic?: InputMaybe<Array<CommCenterTicketTopic>>;
};

export type CommCenterTicket__Order = {
  /** Field to order by */
  field?: InputMaybe<CommCenterTicket__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum CommCenterTicket__OrderField {
  Priority = '_priority',
  Source = '_source',
  Topic = '_topic',
  CaregiverId = 'caregiverId',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  CreatedBySystem = 'createdBySystem',
  EnableAgencyResponse = 'enableAgencyResponse',
  Id = 'id',
  LabelId = 'labelId',
  PatientId = 'patientId',
  PhoneNumber = 'phoneNumber',
  PhonebookContactId = 'phonebookContactId',
  RelatedVisitBroadcastId = 'relatedVisitBroadcastId',
  RelatedVisitInstanceId = 'relatedVisitInstanceId',
  TeamId = 'teamId'
}

export type ContractType = {
  __typename?: 'ContractType';
  active: Scalars['Boolean']['output'];
  id: Scalars['ContractTypeId']['output'];
  name: Scalars['String']['output'];
};

export type ContractTypeConnection = {
  __typename?: 'ContractTypeConnection';
  /** The nodes that match the query */
  nodes: Array<ContractType>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

/** Filter result rows based on the value of a field */
export type ContractTypeId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['ContractTypeId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['ContractTypeId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['ContractTypeId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['ContractTypeId']['input']>>;
};

export type ContractType_RelationFilter = {
  /** Filter based on "active" field */
  active?: InputMaybe<Boolean_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<ContractTypeId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
};

export type ContractType__Order = {
  /** Field to order by */
  field?: InputMaybe<ContractType__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum ContractType__OrderField {
  Active = 'active',
  Id = 'id',
  Name = 'name'
}

/** Filter result rows based on the value of a field */
export type ImportedVisitId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['ImportedVisitId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['ImportedVisitId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['ImportedVisitId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['ImportedVisitId']['input']>>;
};

/** Filter result rows based on the value of a field */
export type Instant_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['Instant']['input']>;
  /** Greater-Than (>) operator */
  gt?: InputMaybe<Scalars['Instant']['input']>;
  /** Greater-Than-or-Equal (>=) operator */
  gte?: InputMaybe<Scalars['Instant']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['Instant']['input']>>;
  /** Less-Than (<) operator */
  lt?: InputMaybe<Scalars['Instant']['input']>;
  /** Less-Than-or-Equal (<) operator */
  lte?: InputMaybe<Scalars['Instant']['input']>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['Instant']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['Instant']['input']>>;
};

/** Filter result rows based on the value of a field */
export type Int_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['Int']['input']>;
  /** Greater-Than (>) operator */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** Greater-Than-or-Equal (>=) operator */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Less-Than (<) operator */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** Less-Than-or-Equal (<) operator */
  lte?: InputMaybe<Scalars['Int']['input']>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Filter result rows based on the value of a field */
export type LocalDateTime_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** Greater-Than (>) operator */
  gt?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** Greater-Than-or-Equal (>=) operator */
  gte?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['LocalDateTime']['input']>>;
  /** Less-Than (<) operator */
  lt?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** Less-Than-or-Equal (<) operator */
  lte?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['LocalDateTime']['input']>>;
};

/** Filter result rows based on the value of a field */
export type LocalDate_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Greater-Than (>) operator */
  gt?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Greater-Than-or-Equal (>=) operator */
  gte?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['LocalDate']['input']>>;
  /** Less-Than (<) operator */
  lt?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Less-Than-or-Equal (<) operator */
  lte?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['LocalDate']['input']>>;
};

/** Filter result rows based on the value of a field */
export type MedflytChrcDataId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['MedflytCHRCDataId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['MedflytCHRCDataId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['MedflytCHRCDataId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['MedflytCHRCDataId']['input']>>;
};

/** Filter result rows based on the value of a field */
export type MedflytHcrDataId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['MedflytHCRDataId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['MedflytHCRDataId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['MedflytHCRDataId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['MedflytHCRDataId']['input']>>;
};

export type Note = {
  __typename?: 'Note';
  caregiver: AgencyMemberCaregiver;
  caregiverId: Scalars['CaregiverId']['output'];
  createdAt: Scalars['Instant']['output'];
  id: Scalars['NoteId']['output'];
  noteRichText: Scalars['String']['output'];
  patient: Patient;
  patientId: Scalars['PatientId']['output'];
};

export type NoteConnection = {
  __typename?: 'NoteConnection';
  /** The nodes that match the query */
  nodes: Array<Note>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

/** Filter result rows based on the value of a field */
export type NoteId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['NoteId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['NoteId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['NoteId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['NoteId']['input']>>;
};

export type Note_RelationFilter = {
  /** Filter based on "caregiverId" field */
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<NoteId_Filter>;
  /** Filter based on "patientId" field */
  patientId?: InputMaybe<PatientId_Filter>;
};

export type Note__Order = {
  /** Field to order by */
  field?: InputMaybe<Note__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum Note__OrderField {
  CaregiverId = 'caregiverId',
  CreatedAt = 'createdAt',
  Id = 'id',
  PatientId = 'patientId'
}

/** Filter result rows based on the value of a field */
export type OfficeId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['OfficeId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['OfficeId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['OfficeId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['OfficeId']['input']>>;
};

export type Patient = {
  __typename?: 'Patient';
  active: Scalars['Boolean']['output'];
  activeContracts: PatientActiveContractsConnection;
  additionalAddresses: PatientAdditionalAddressesConnection;
  address?: Maybe<Scalars['String']['output']>;
  agencyBranches: AgencyBranchPatientAssocConnection;
  agencyTeam?: Maybe<AgencyTeam>;
  agencyTeamId?: Maybe<Scalars['AgencyTeamId']['output']>;
  assignedCoordinator?: Maybe<AgencyMemberAgencyMember>;
  assignedCoordinatorId?: Maybe<Scalars['AgencyMemberId']['output']>;
  authorizations: PatientAuthorizationConnection;
  createdAt: Scalars['Instant']['output'];
  createdBy: AgencyMemberAgencyMember;
  createdById: Scalars['AgencyMemberId']['output'];
  currentOffice: AgencyMemberOffice;
  currentOfficeId: Scalars['OfficeId']['output'];
  customFields: Scalars['EntityCustomField']['output'];
  dateOfBirth?: Maybe<Scalars['LocalDate']['output']>;
  displayId?: Maybe<Scalars['Int']['output']>;
  effectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  firstName: Scalars['String']['output'];
  firstStartOfCare?: Maybe<PatientCertificationPeriod>;
  firstStartOfCareCertificationPeriodId?: Maybe<Scalars['CertificationPeriodId']['output']>;
  gender?: Maybe<Scalars['PatientGender']['output']>;
  hasEmergencyKardexInfo: Scalars['Boolean']['output'];
  hasPhysicianInfo: Scalars['Boolean']['output'];
  homePhoneNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['PatientId']['output'];
  lastName: Scalars['String']['output'];
  lastReassessment?: Maybe<PatientCertificationPeriod>;
  lastReassessmentCertificationPeriodId?: Maybe<Scalars['CertificationPeriodId']['output']>;
  lastStartOfCare?: Maybe<PatientCertificationPeriod>;
  lastStartOfCareCertificationPeriodId?: Maybe<Scalars['CertificationPeriodId']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  mobilePhoneNumber?: Maybe<Scalars['String']['output']>;
  nextReassessment?: Maybe<PatientCertificationPeriod>;
  nextReassessmentCertificationPeriodId?: Maybe<Scalars['CertificationPeriodId']['output']>;
  phoneNumbers: PatientPhoneNumberConnection;
  primaryAddress: PatientPrimaryAddress;
  /** Social Security Number */
  ssn?: Maybe<Scalars['String']['output']>;
  startOfCare?: Maybe<Scalars['LocalDate']['output']>;
  status: Scalars['PatientStatus']['output'];
  visitInstances: AgencyMemberVisitInstanceConnection;
};


export type PatientActiveContractsArgs = {
  contractType?: InputMaybe<ContractType_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientContract?: InputMaybe<PatientContract_RelationFilter>;
};


export type PatientAdditionalAddressesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PatientAgencyBranchesArgs = {
  agencyBranch?: InputMaybe<AgencyBranch_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patient?: InputMaybe<Patient_RelationFilter>;
};


export type PatientAuthorizationsArgs = {
  authorizationCode?: InputMaybe<String_Filter>;
  endDate?: InputMaybe<LocalDate_Filter>;
  id?: InputMaybe<AuthorizationId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientAuthorization__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientContract?: InputMaybe<PatientContract_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
  serviceCode?: InputMaybe<ServiceCode_RelationFilter>;
  startDate?: InputMaybe<LocalDate_Filter>;
};


export type PatientPhoneNumbersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PatientVisitInstancesArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']['input']>;
  id?: InputMaybe<VisitInstanceId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberVisitInstance__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
};

export type PatientActiveContracts = {
  __typename?: 'PatientActiveContracts';
  contractType: ContractType;
  contractTypeId: Scalars['ContractTypeId']['output'];
  patientContract: PatientContract;
  patientContractId: Scalars['PatientContractId']['output'];
  patientId: Scalars['PatientId']['output'];
};

export type PatientActiveContractsConnection = {
  __typename?: 'PatientActiveContractsConnection';
  /** The nodes that match the query */
  nodes: Array<PatientActiveContracts>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type PatientAdditionalAddresses = {
  __typename?: 'PatientAdditionalAddresses';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  geo?: Maybe<Scalars['Geo']['output']>;
  patientId: Scalars['PatientId']['output'];
  state?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  zip4?: Maybe<Scalars['String']['output']>;
  zip5?: Maybe<Scalars['String']['output']>;
  zip9?: Maybe<Scalars['String']['output']>;
};

export type PatientAdditionalAddressesConnection = {
  __typename?: 'PatientAdditionalAddressesConnection';
  /** The nodes that match the query */
  nodes: Array<PatientAdditionalAddresses>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type PatientAuthorization = {
  __typename?: 'PatientAuthorization';
  authorizationCode?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['LocalDate']['output'];
  id: Scalars['AuthorizationId']['output'];
  /** NULL value means unlimited */
  maxMinutes?: Maybe<Scalars['Int']['output']>;
  patient: Patient;
  patientContract: PatientContract;
  patientId: Scalars['PatientId']['output'];
  periodUtilizations: PatientAuthorizationPeriodUtilizationConnection;
  serviceCode: ServiceCode;
  startDate: Scalars['LocalDate']['output'];
  timeConfig: Scalars['AuthorizationTimeConfig']['output'];
};


export type PatientAuthorizationPeriodUtilizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  numIncorrectlyAllocatedVisits?: InputMaybe<Int_Filter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientAuthorizationPeriodUtilization__Order>>>;
  periodOverAllocated?: InputMaybe<Boolean_Filter>;
  periodUnderUtilized?: InputMaybe<Boolean_Filter>;
};

export type PatientAuthorizationConnection = {
  __typename?: 'PatientAuthorizationConnection';
  /** The nodes that match the query */
  nodes: Array<PatientAuthorization>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type PatientAuthorizationPeriodUtilization = {
  __typename?: 'PatientAuthorizationPeriodUtilization';
  /** running total of the allocated minutes (chronologically) (including this period) */
  minutesAllocatedInAuthorization: Scalars['Int']['output'];
  /** total minutes actually allocated in this period (simple sum over visit_allocation) */
  minutesAllocatedInPeriod: Scalars['Int']['output'];
  /** total minutes available in this period (doesn't look at actual allocations) */
  minutesAvailableInPeriod: Scalars['Int']['output'];
  /** remaining based on running total */
  minutesRemainingInAuthorization: Scalars['Int']['output'];
  /** minutes_available_in_period - minutes_allocated_in_period */
  minutesRemainingInPeriod: Scalars['Int']['output'];
  /** number of visits within this period that potentially match this authorization and have an incorrectly allocated amount. If greater than 0 then this period should be flagged. */
  numIncorrectlyAllocatedVisits: Scalars['Int']['output'];
  /** DATE of last day of period */
  periodEnd: Scalars['LocalDate']['output'];
  /** period is over-allocated */
  periodOverAllocated: Scalars['Boolean']['output'];
  /** DATE of first day of period */
  periodStart: Scalars['LocalDate']['output'];
  /** minutes_remaining_in_period > 0 */
  periodUnderUtilized: Scalars['Boolean']['output'];
  /** TODO ??? */
  totalAuthorizationMinutesFree: Scalars['Int']['output'];
  /** TODO ??? */
  totalAuthorizationMinutesUsed: Scalars['Int']['output'];
};

export type PatientAuthorizationPeriodUtilizationConnection = {
  __typename?: 'PatientAuthorizationPeriodUtilizationConnection';
  /** The nodes that match the query */
  nodes: Array<PatientAuthorizationPeriodUtilization>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type PatientAuthorizationPeriodUtilization__Order = {
  /** Field to order by */
  field?: InputMaybe<PatientAuthorizationPeriodUtilization__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum PatientAuthorizationPeriodUtilization__OrderField {
  /** number of visits within this period that potentially match this authorization and have an incorrectly allocated amount. If greater than 0 then this period should be flagged. */
  NumIncorrectlyAllocatedVisits = 'numIncorrectlyAllocatedVisits',
  /** period is over-allocated */
  PeriodOverAllocated = 'periodOverAllocated',
  /** minutes_remaining_in_period > 0 */
  PeriodUnderUtilized = 'periodUnderUtilized'
}

export type PatientAuthorization_RelationFilter = {
  /** Filter based on "authorizationCode" field */
  authorizationCode?: InputMaybe<String_Filter>;
  /** Filter based on "endDate" field */
  endDate?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<AuthorizationId_Filter>;
  /** Filter based on "patientId" field */
  patientId?: InputMaybe<PatientId_Filter>;
  /** Filter based on "startDate" field */
  startDate?: InputMaybe<LocalDate_Filter>;
};

export type PatientAuthorization__Order = {
  /** Field to order by */
  field?: InputMaybe<PatientAuthorization__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum PatientAuthorization__OrderField {
  AuthorizationCode = 'authorizationCode',
  EndDate = 'endDate',
  Id = 'id',
  PatientId = 'patientId',
  StartDate = 'startDate'
}

export type PatientCertificationPeriod = {
  __typename?: 'PatientCertificationPeriod';
  containsRunDate: Scalars['Boolean']['output'];
  daysFromEndDate: Scalars['Int']['output'];
  daysFromStartDate: Scalars['Int']['output'];
  documents: Scalars['Int']['output'];
  endDate: Scalars['LocalDate']['output'];
  hasActiveTaskInstance: Scalars['Boolean']['output'];
  id: Scalars['CertificationPeriodId']['output'];
  isCompleted: Scalars['Boolean']['output'];
  latestTaskInstance?: Maybe<PatientTaskInstance>;
  latestTaskInstanceId?: Maybe<Scalars['PatientTaskInstanceId']['output']>;
  patient: Patient;
  patientId: Scalars['PatientId']['output'];
  patientTask?: Maybe<PatientTask>;
  startDate: Scalars['LocalDate']['output'];
  submitted: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type PatientConnection = {
  __typename?: 'PatientConnection';
  /** The nodes that match the query */
  nodes: Array<Patient>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type PatientContract = {
  __typename?: 'PatientContract';
  contractType: ContractType;
  contractTypeId: Scalars['ContractTypeId']['output'];
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['PatientContractId']['output'];
  medicaidNumber?: Maybe<Scalars['String']['output']>;
  memberId: Scalars['String']['output'];
};

export type PatientContract_RelationFilter = {
  /** Filter based on "endDate" field */
  endDate?: InputMaybe<LocalDate_Filter>;
};

export type PatientCustomFields = {
  __typename?: 'PatientCustomFields';
  customField: Scalars['String']['output'];
};

export type PatientCustomFieldsConnection = {
  __typename?: 'PatientCustomFieldsConnection';
  /** The nodes that match the query */
  nodes: Array<PatientCustomFields>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

/** Filter result rows based on the value of a field */
export type PatientId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['PatientId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['PatientId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['PatientId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['PatientId']['input']>>;
};

export type PatientIssue = {
  __typename?: 'PatientIssue';
  _severity: Scalars['String']['output'];
  _status: Scalars['String']['output'];
  _tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _type: Scalars['String']['output'];
  assignedAgencyMemberId: Scalars['AgencyMemberId']['output'];
  assigned_agency_member?: Maybe<AgencyMemberAgencyMember>;
  caregiver?: Maybe<AgencyMemberCaregiver>;
  caregiverId?: Maybe<Scalars['CaregiverId']['output']>;
  createdAt: Scalars['Instant']['output'];
  description: Scalars['String']['output'];
  id: Scalars['PatientIssueId']['output'];
  patient: Patient;
  patientId: Scalars['PatientId']['output'];
  resolutionDescription?: Maybe<Scalars['String']['output']>;
  resulttedAt?: Maybe<Scalars['Instant']['output']>;
  resulttedBy?: Maybe<Scalars['AgencyMemberId']['output']>;
  resultted_by?: Maybe<AgencyMemberAgencyMember>;
  severity: PatientIssueSeverity;
  sourceTicketId: Scalars['CommCenterTicketId']['output'];
  status: PatientIssueStatus;
  tags?: Maybe<Array<PatientIssueTag>>;
  type: PatientIssueType;
};

export type PatientIssueConnection = {
  __typename?: 'PatientIssueConnection';
  /** The nodes that match the query */
  nodes: Array<PatientIssue>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

/** Filter result rows based on the value of a field */
export type PatientIssueId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['PatientIssueId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['PatientIssueId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['PatientIssueId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['PatientIssueId']['input']>>;
};

export enum PatientIssueSeverity {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export enum PatientIssueStatus {
  InProgress = 'In_Progress',
  NotRelevant = 'Not_Relevant',
  Open = 'Open',
  Resolved = 'Resolved'
}

export enum PatientIssueTag {
  Hr = 'HR',
  NotifyMltc = 'Notify_MLTC',
  Nursing = 'Nursing',
  Retention = 'Retention',
  Staffing = 'Staffing'
}

export enum PatientIssueType {
  Complaint = 'Complaint',
  Incident = 'Incident'
}

export type PatientIssue__Order = {
  /** Field to order by */
  field?: InputMaybe<PatientIssue__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum PatientIssue__OrderField {
  Severity = '_severity',
  Status = '_status',
  Tags = '_tags',
  Type = '_type',
  AssignedAgencyMemberId = 'assignedAgencyMemberId',
  CaregiverId = 'caregiverId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  PatientId = 'patientId',
  ResolutionDescription = 'resolutionDescription',
  ResulttedAt = 'resulttedAt',
  ResulttedBy = 'resulttedBy',
  SourceTicketId = 'sourceTicketId'
}

export type PatientPhoneNumber = {
  __typename?: 'PatientPhoneNumber';
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  patientId: Scalars['PatientId']['output'];
  phonenumber: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PatientPhoneNumberConnection = {
  __typename?: 'PatientPhoneNumberConnection';
  /** The nodes that match the query */
  nodes: Array<PatientPhoneNumber>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type PatientPrimaryAddress = {
  __typename?: 'PatientPrimaryAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  county: Scalars['String']['output'];
  geo?: Maybe<Scalars['Geo']['output']>;
  patientId: Scalars['PatientId']['output'];
  state: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  zip4?: Maybe<Scalars['String']['output']>;
  zip5?: Maybe<Scalars['String']['output']>;
  zip9?: Maybe<Scalars['String']['output']>;
};

export enum PatientQualifiedLeadReason {
  QualifiedManually = 'QualifiedManually',
  QualifiedStatusWithIntakeCall = 'QualifiedStatusWithIntakeCall',
  QualifiedStatusWithMaxAge = 'QualifiedStatusWithMaxAge',
  QualifiedStatusWithMedicaid = 'QualifiedStatusWithMedicaid'
}

export type PatientTask = {
  __typename?: 'PatientTask';
  caregiverId?: Maybe<Scalars['CaregiverId']['output']>;
  certificationPeriodId?: Maybe<Scalars['CertificationPeriodId']['output']>;
  daysFromDueDate: Scalars['Int']['output'];
  daysFromStartDate: Scalars['Int']['output'];
  dueDate: Scalars['LocalDate']['output'];
  id: Scalars['PatientTaskId']['output'];
  isCanceled: Scalars['Boolean']['output'];
  isDraft: Scalars['Boolean']['output'];
  isRemoved: Scalars['Boolean']['output'];
  patientId: Scalars['PatientId']['output'];
  repeatMonths?: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['LocalDate']['output'];
  taskInstance: PatientTaskInstanceConnection;
  title: Scalars['String']['output'];
};


export type PatientTaskTaskInstanceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PatientTaskInstance = {
  __typename?: 'PatientTaskInstance';
  completionDate?: Maybe<Scalars['LocalDate']['output']>;
  daysFromDueDate: Scalars['Int']['output'];
  daysFromStartDate: Scalars['Int']['output'];
  dueDate: Scalars['LocalDate']['output'];
  durationMinutes: Scalars['Int']['output'];
  id: Scalars['PatientTaskInstanceId']['output'];
  isCanceled: Scalars['Boolean']['output'];
  isRemoved: Scalars['Boolean']['output'];
  startDate: Scalars['LocalDate']['output'];
  taskId: Scalars['PatientTaskId']['output'];
};

export type PatientTaskInstanceConnection = {
  __typename?: 'PatientTaskInstanceConnection';
  /** The nodes that match the query */
  nodes: Array<PatientTaskInstance>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

/** Filter result rows based on the value of a field */
export type PatientWebsiteVisitorEventId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['PatientWebsiteVisitorEventId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['PatientWebsiteVisitorEventId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['PatientWebsiteVisitorEventId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['PatientWebsiteVisitorEventId']['input']>>;
};

/** Filter result rows based on the value of a field */
export type PatientWebsiteVisitorId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['PatientWebsiteVisitorId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['PatientWebsiteVisitorId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['PatientWebsiteVisitorId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['PatientWebsiteVisitorId']['input']>>;
};

/** Filter result rows based on the value of a field */
export type PatientWebsiteVisitorVisitId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['PatientWebsiteVisitorVisitId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['PatientWebsiteVisitorVisitId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['PatientWebsiteVisitorVisitId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['PatientWebsiteVisitorVisitId']['input']>>;
};

export type Patient_RelationFilter = {
  /** Filter based on "active" field */
  active?: InputMaybe<Boolean_Filter>;
  addressSearch?: InputMaybe<Scalars['String']['input']>;
  agencyBranchId?: InputMaybe<Array<Scalars['AgencyBranchId']['input']>>;
  /** Filter based on "agencyTeamId" field */
  agencyTeamId?: InputMaybe<AgencyTeamId_Filter>;
  /** Filter based on "assignedCoordinatorId" field */
  assignedCoordinatorId?: InputMaybe<AgencyMemberId_Filter>;
  contractTypeId?: InputMaybe<Array<Scalars['ContractTypeId']['input']>>;
  /** Filter based on "createdAt" field */
  createdAt?: InputMaybe<Instant_Filter>;
  /** Filter based on "createdById" field */
  createdById?: InputMaybe<AgencyMemberId_Filter>;
  /** Filter based on "currentOfficeId" field */
  currentOfficeId?: InputMaybe<OfficeId_Filter>;
  /** Filter based on "displayId" field */
  displayId?: InputMaybe<Int_Filter>;
  displayIdSearch?: InputMaybe<Scalars['String']['input']>;
  /** Filter based on "effectiveDate" field */
  effectiveDate?: InputMaybe<LocalDate_Filter>;
  /** Filter based on "firstName" field */
  firstName?: InputMaybe<String_Filter>;
  firstNameSearch?: InputMaybe<Scalars['String']['input']>;
  /** Filter based on "hasEmergencyKardexInfo" field */
  hasEmergencyKardexInfo?: InputMaybe<Boolean_Filter>;
  /** Filter based on "hasPhysicianInfo" field */
  hasPhysicianInfo?: InputMaybe<Boolean_Filter>;
  homePhoneSearch?: InputMaybe<Scalars['String']['input']>;
  /** Filter based on "id" field */
  id?: InputMaybe<PatientId_Filter>;
  /** Filter based on "lastName" field */
  lastName?: InputMaybe<String_Filter>;
  lastNameSearch?: InputMaybe<Scalars['String']['input']>;
  mobilePhoneSearch?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter based on "ssn" field */
  ssn?: InputMaybe<String_Filter>;
  /** Filter based on "startOfCare" field */
  startOfCare?: InputMaybe<LocalDate_Filter>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Patient__Order = {
  /** Field to order by */
  field?: InputMaybe<Patient__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum Patient__OrderField {
  Active = 'active',
  Address = 'address',
  AgencyTeamId = 'agencyTeamId',
  AssignedCoordinatorId = 'assignedCoordinatorId',
  CreatedAt = 'createdAt',
  CreatedById = 'createdById',
  CurrentOfficeId = 'currentOfficeId',
  DateOfBirth = 'dateOfBirth',
  DisplayId = 'displayId',
  EffectiveDate = 'effectiveDate',
  FirstName = 'firstName',
  HasEmergencyKardexInfo = 'hasEmergencyKardexInfo',
  HasPhysicianInfo = 'hasPhysicianInfo',
  Id = 'id',
  LastName = 'lastName',
  /** Social Security Number */
  Ssn = 'ssn',
  StartOfCare = 'startOfCare',
  StatusHidden = 'statusHidden'
}

/** Filter result rows based on the value of a field */
export type PayerId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['PayerId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['PayerId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['PayerId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['PayerId']['input']>>;
};

export type PhonebookContact = {
  __typename?: 'PhonebookContact';
  destinationNumberType: Scalars['String']['output'];
  id: Scalars['AgencyPhonebookContactId']['output'];
  inboundCommCenterLabel: CommCenterLabel;
  inboundCommCenterLabelId: Scalars['CommCenterLabelId']['output'];
  name: Scalars['String']['output'];
  outboundCommCenterLabel: CommCenterLabel;
  outboundCommCenterLabelId: Scalars['CommCenterLabelId']['output'];
  payerId?: Maybe<Scalars['PayerId']['output']>;
  phoneNumber: Scalars['String']['output'];
  phonebookContactType?: Maybe<Scalars['String']['output']>;
};

export type PhonebookContactConnection = {
  __typename?: 'PhonebookContactConnection';
  /** The nodes that match the query */
  nodes: Array<PhonebookContact>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type PhonebookContact_RelationFilter = {
  /** Filter based on "destinationNumberType" field */
  destinationNumberType?: InputMaybe<String_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<AgencyPhonebookContactId_Filter>;
  /** Filter based on "inboundCommCenterLabelId" field */
  inboundCommCenterLabelId?: InputMaybe<CommCenterLabelId_Filter>;
  /** Filter based on "name" field */
  name?: InputMaybe<String_Filter>;
  /** Filter based on "outboundCommCenterLabelId" field */
  outboundCommCenterLabelId?: InputMaybe<CommCenterLabelId_Filter>;
  /** Filter based on "payerId" field */
  payerId?: InputMaybe<PayerId_Filter>;
  /** Filter based on "phoneNumber" field */
  phoneNumber?: InputMaybe<String_Filter>;
  /** Filter based on "phonebookContactType" field */
  phonebookContactType?: InputMaybe<String_Filter>;
};

export type PhonebookContact__Order = {
  /** Field to order by */
  field?: InputMaybe<PhonebookContact__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum PhonebookContact__OrderField {
  DestinationNumberType = 'destinationNumberType',
  Id = 'id',
  InboundCommCenterLabelId = 'inboundCommCenterLabelId',
  Name = 'name',
  OutboundCommCenterLabelId = 'outboundCommCenterLabelId',
  PayerId = 'payerId',
  PhoneNumber = 'phoneNumber',
  PhonebookContactType = 'phonebookContactType'
}

export type Query = {
  __typename?: 'Query';
  /** All of Agencies that the AgencyMember can see */
  agencies: AgencyMemberAgencyConnection;
  agencyBranches: AgencyBranchConnection;
  /** All of the agency members */
  agencyMembers: AgencyMemberAgencyMemberConnection;
  agencyTeams: AgencyTeamConnection;
  /** authorized_patients_without_visits sql view */
  authorizedPatientsWithoutVisits: AuthorizedPatientWithoutVisitsViewConnection;
  /** All of Caregivers that the AgencyMember can see */
  caregivers: AgencyMemberCaregiverConnection;
  /** Caregivers and their respective CHRC compliance */
  caregiversChrcCompliance: AgencyMemberCaregiverChrcComplianceConnection;
  /** Caregivers and their respective HCR compliance */
  caregiversHcrCompliance: AgencyMemberCaregiverHcrComplianceConnection;
  /** The agency's state compliance regarding caregivers and CHRC/HCR */
  caregiversStateComplianceIssues: AgencyMemberCaregiverStateComplianceConnection;
  contractTypes: ContractTypeConnection;
  /** All of VisitInstances that the AgencyMember can see */
  importedVisits: AgencyMemberImportedVisitConnection;
  notes: NoteConnection;
  /** All of Offices the AgencyMember can see */
  offices: AgencyMemberOfficeConnection;
  /** All of PatientAuthorizations that the AgencyMember can see */
  patientAuthorizations: PatientAuthorizationConnection;
  /** All of Patient Custom Fields that are used by an Agency */
  patientCustomFields: PatientCustomFieldsConnection;
  /** All of PatientIssues that the AgencyMember can see */
  patientIssues: PatientIssueConnection;
  /** Patient lead qualifications */
  patientLeadQualifications: AgencyMemberPatientLeadQualificationsConnection;
  /** Patient website visitor event */
  patientWebsiteVisitorEvents: AgencyMemberPatientWebsiteVisitorEventConnection;
  /** Patient website visitor visit */
  patientWebsiteVisitorVisits: AgencyMemberPatientWebsiteVisitorVisitConnection;
  /** Patient website visitor */
  patientWebsiteVisitors: AgencyMemberPatientWebsiteVisitorConnection;
  /** All of Patients that the AgencyMember can see */
  patients: PatientConnection;
  /** phonebook contacts */
  phonebookContacts: PhonebookContactConnection;
  /** All of ReferralUsers that the AgencyMember can see */
  referralUsers: ReferralUserConnection;
  /** comm center tickets */
  tickets: CommCenterTicketConnection;
  visitAssignments: VisitAssignmentConnection;
  visitAssignmentsDistinct: VisitAssignmentDistinctConnection;
  /** All of VisitBroadcasts that the AgencyMember can see */
  visitBroadcasts: AgencyMemberVisitBroadcastConnection;
  /** All of VisitInstances that the AgencyMember can see */
  visitInstances: AgencyMemberVisitInstanceConnection;
  /** All of the AvailableWorkflowTaskInstance that the AgencyMember can see */
  workflowAvailableTaskInstances: AgencyMemberAvailableWorkflowTaskInstanceConnection;
  /** All of WorkflowDefinitions that the AgencyMember can see */
  workflowDefinitions: AgencyMemberWorkflowDefinitionConnection;
  /** All of WorkflowInstances that the AgencyMember can see */
  workflowInstances: AgencyMemberWorkflowInstanceConnection;
  /** Workflow tags */
  workflowTags: AgencyMemberWorkflowTagConnection;
  /** Workflow task definition fields */
  workflowTaskDefinitions: AgencyMemberWorkflowTaskDefinitionConnection;
  /** Workflow task instance input fields */
  workflowTaskInstanceInputs: AgencyMemberWorkflowTaskInstanceInputConnection;
  /** Workflow task instance tags */
  workflowTaskInstanceTags: AgencyMemberWorkflowTaskInstanceTagConnection;
  /** Workflow task instances */
  workflowTaskInstances: AgencyMemberWorkflowTaskInstanceConnection;
};


export type QueryAgenciesArgs = {
  id?: InputMaybe<AgencyId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberAgency__Order>>>;
};


export type QueryAgencyBranchesArgs = {
  id?: InputMaybe<AgencyBranchId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyBranch__Order>>>;
};


export type QueryAgencyMembersArgs = {
  agency?: InputMaybe<AgencyMemberAgency_RelationFilter>;
  agencyId?: InputMaybe<AgencyId_Filter>;
  id?: InputMaybe<AgencyMemberId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nameSearch?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberAgencyMember__Order>>>;
};


export type QueryAgencyTeamsArgs = {
  active?: InputMaybe<Boolean_Filter>;
  id?: InputMaybe<AgencyTeamId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyTeam__Order>>>;
  teamLeader?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
};


export type QueryAuthorizedPatientsWithoutVisitsArgs = {
  endDate?: InputMaybe<LocalDate_Filter>;
  from?: InputMaybe<Scalars['LocalDate']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AuthorizedPatientWithoutVisitsView__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientAuthorization?: InputMaybe<PatientAuthorization_RelationFilter>;
  patientAuthorizationId?: InputMaybe<AuthorizationId_Filter>;
  patientId?: InputMaybe<PatientId_Filter>;
  startDate?: InputMaybe<LocalDate_Filter>;
  to?: InputMaybe<Scalars['LocalDate']['input']>;
};


export type QueryCaregiversArgs = {
  chrcCompliance?: InputMaybe<AgencyMemberCaregiverChrcCompliance_RelationFilter>;
  createdAt?: InputMaybe<Instant_Filter>;
  firstName?: InputMaybe<String_Filter>;
  hcrCompliance?: InputMaybe<AgencyMemberCaregiverHcrCompliance_RelationFilter>;
  id?: InputMaybe<CaregiverId_Filter>;
  lastName?: InputMaybe<String_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nameSearch?: InputMaybe<Scalars['Instant']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberCaregiver__Order>>>;
};


export type QueryCaregiversChrcComplianceArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']['input']>>;
  chrcDateOfBirth?: InputMaybe<LocalDate_Filter>;
  chrcEmployeeName?: InputMaybe<String_Filter>;
  chrcStartDate?: InputMaybe<LocalDate_Filter>;
  chrcStatus?: InputMaybe<String_Filter>;
  chrcStatusDate?: InputMaybe<LocalDate_Filter>;
  dateOfBirth?: InputMaybe<LocalDate_Filter>;
  fromChrcStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  fromHireDate?: InputMaybe<Scalars['LocalDate']['input']>;
  hireDate?: InputMaybe<LocalDate_Filter>;
  id?: InputMaybe<MedflytChrcDataId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyUnmatched?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberCaregiverChrcCompliance__Order>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  stateRegistryNum?: InputMaybe<Int_Filter>;
  status?: InputMaybe<String_Filter>;
  terminationDate?: InputMaybe<LocalDate_Filter>;
  toChrcStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  toHireDate?: InputMaybe<Scalars['LocalDate']['input']>;
};


export type QueryCaregiversHcrComplianceArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']['input']>>;
  dateOfBirth?: InputMaybe<LocalDate_Filter>;
  fromHireDate?: InputMaybe<Scalars['LocalDate']['input']>;
  hcrCertificateType?: InputMaybe<String_Filter>;
  hcrDateOfBirth?: InputMaybe<LocalDate_Filter>;
  hcrFullName?: InputMaybe<String_Filter>;
  hcrHireDate?: InputMaybe<LocalDate_Filter>;
  hcrSeparationDate?: InputMaybe<LocalDate_Filter>;
  hcrStateRegistryNumber?: InputMaybe<Int_Filter>;
  hireDate?: InputMaybe<LocalDate_Filter>;
  id?: InputMaybe<MedflytHcrDataId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyUnmatched?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberCaregiverHcrCompliance__Order>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  stateRegistryNum?: InputMaybe<Int_Filter>;
  status?: InputMaybe<String_Filter>;
  terminationDate?: InputMaybe<LocalDate_Filter>;
  toHireDate?: InputMaybe<Scalars['LocalDate']['input']>;
};


export type QueryCaregiversStateComplianceIssuesArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  issue?: InputMaybe<String_Filter>;
  issueTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberCaregiverStateCompliance__Order>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContractTypesArgs = {
  active?: InputMaybe<Boolean_Filter>;
  id?: InputMaybe<ContractTypeId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContractType__Order>>>;
};


export type QueryImportedVisitsArgs = {
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']['input']>;
  endTimeLocal?: InputMaybe<LocalDateTime_Filter>;
  id?: InputMaybe<ImportedVisitId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberImportedVisit__Order>>>;
  startTimeLocal?: InputMaybe<LocalDateTime_Filter>;
};


export type QueryNotesArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  id?: InputMaybe<NoteId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Note__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
};


export type QueryOfficesArgs = {
  id?: InputMaybe<OfficeId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberOffice__Order>>>;
};


export type QueryPatientAuthorizationsArgs = {
  authorizationCode?: InputMaybe<String_Filter>;
  endDate?: InputMaybe<LocalDate_Filter>;
  id?: InputMaybe<AuthorizationId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientAuthorization__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientContract?: InputMaybe<PatientContract_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
  serviceCode?: InputMaybe<ServiceCode_RelationFilter>;
  startDate?: InputMaybe<LocalDate_Filter>;
};


export type QueryPatientCustomFieldsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPatientIssuesArgs = {
  _severity?: InputMaybe<String_Filter>;
  _status?: InputMaybe<String_Filter>;
  _tags?: InputMaybe<String_List_Filter>;
  _type?: InputMaybe<String_Filter>;
  assignedAgencyMemberId?: InputMaybe<AgencyMemberId_Filter>;
  assigned_agency_member?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAt?: InputMaybe<Instant_Filter>;
  description?: InputMaybe<String_Filter>;
  from?: InputMaybe<Scalars['LocalDate']['input']>;
  id?: InputMaybe<PatientIssueId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  officeIds?: InputMaybe<Array<Scalars['OfficeId']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientIssue__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
  resolutionDescription?: InputMaybe<String_Filter>;
  resulttedAt?: InputMaybe<Instant_Filter>;
  resulttedBy?: InputMaybe<AgencyMemberId_Filter>;
  resultted_by?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  severities?: InputMaybe<Array<PatientIssueSeverity>>;
  sourceTicketId?: InputMaybe<CommCenterTicketId_Filter>;
  statuses?: InputMaybe<Array<PatientIssueStatus>>;
  tags?: InputMaybe<Array<PatientIssueTag>>;
  to?: InputMaybe<Scalars['LocalDate']['input']>;
  types?: InputMaybe<Array<PatientIssueType>>;
};


export type QueryPatientLeadQualificationsArgs = {
  disqualifiedAt?: InputMaybe<Instant_Filter>;
  isQualified?: InputMaybe<Boolean_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberPatientLeadQualifications__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
  qualifiedAt?: InputMaybe<Instant_Filter>;
  qualifiedReason?: InputMaybe<String_Filter>;
};


export type QueryPatientWebsiteVisitorEventsArgs = {
  createdAt?: InputMaybe<Instant_Filter>;
  eventName?: InputMaybe<String_Filter>;
  eventType?: InputMaybe<String_Filter>;
  id?: InputMaybe<PatientWebsiteVisitorEventId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberPatientWebsiteVisitorEvent__Order>>>;
  visit?: InputMaybe<AgencyMemberPatientWebsiteVisitorVisit_RelationFilter>;
  visitId?: InputMaybe<PatientWebsiteVisitorVisitId_Filter>;
  visitor?: InputMaybe<AgencyMemberPatientWebsiteVisitor_RelationFilter>;
  websiteVisitorId?: InputMaybe<PatientWebsiteVisitorId_Filter>;
};


export type QueryPatientWebsiteVisitorVisitsArgs = {
  adContent?: InputMaybe<String_Filter>;
  adGroup?: InputMaybe<String_Filter>;
  assignedPhoneNumber?: InputMaybe<String_Filter>;
  campaign?: InputMaybe<String_Filter>;
  createdAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<PatientWebsiteVisitorVisitId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  medium?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberPatientWebsiteVisitorVisit__Order>>>;
  searchTerm?: InputMaybe<String_Filter>;
  source?: InputMaybe<String_Filter>;
  visitor?: InputMaybe<AgencyMemberPatientWebsiteVisitor_RelationFilter>;
  websiteVisitorId?: InputMaybe<PatientWebsiteVisitorId_Filter>;
};


export type QueryPatientWebsiteVisitorsArgs = {
  createdAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<PatientWebsiteVisitorId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberPatientWebsiteVisitor__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
  uuid?: InputMaybe<String_Filter>;
};


export type QueryPatientsArgs = {
  active?: InputMaybe<Boolean_Filter>;
  addressSearch?: InputMaybe<Scalars['String']['input']>;
  agencyBranchId?: InputMaybe<Array<Scalars['AgencyBranchId']['input']>>;
  agencyTeam?: InputMaybe<AgencyTeam_RelationFilter>;
  agencyTeamId?: InputMaybe<AgencyTeamId_Filter>;
  assignedCoordinator?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  assignedCoordinatorId?: InputMaybe<AgencyMemberId_Filter>;
  contractTypeId?: InputMaybe<Array<Scalars['ContractTypeId']['input']>>;
  createdAt?: InputMaybe<Instant_Filter>;
  createdBy?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  createdById?: InputMaybe<AgencyMemberId_Filter>;
  currentOffice?: InputMaybe<AgencyMemberOffice_RelationFilter>;
  currentOfficeId?: InputMaybe<OfficeId_Filter>;
  displayId?: InputMaybe<Int_Filter>;
  displayIdSearch?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<LocalDate_Filter>;
  firstName?: InputMaybe<String_Filter>;
  firstNameSearch?: InputMaybe<Scalars['String']['input']>;
  hasEmergencyKardexInfo?: InputMaybe<Boolean_Filter>;
  hasPhysicianInfo?: InputMaybe<Boolean_Filter>;
  homePhoneSearch?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<PatientId_Filter>;
  lastName?: InputMaybe<String_Filter>;
  lastNameSearch?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mobilePhoneSearch?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Patient__Order>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<String_Filter>;
  startOfCare?: InputMaybe<LocalDate_Filter>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPhonebookContactsArgs = {
  destinationNumberType?: InputMaybe<String_Filter>;
  id?: InputMaybe<AgencyPhonebookContactId_Filter>;
  inboundCommCenterLabel?: InputMaybe<CommCenterLabel_RelationFilter>;
  inboundCommCenterLabelId?: InputMaybe<CommCenterLabelId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<PhonebookContact__Order>>>;
  outboundCommCenterLabel?: InputMaybe<CommCenterLabel_RelationFilter>;
  outboundCommCenterLabelId?: InputMaybe<CommCenterLabelId_Filter>;
  payerId?: InputMaybe<PayerId_Filter>;
  phoneNumber?: InputMaybe<String_Filter>;
  phonebookContactType?: InputMaybe<String_Filter>;
};


export type QueryReferralUsersArgs = {
  createdAt?: InputMaybe<Instant_Filter>;
  email?: InputMaybe<String_Filter>;
  emailSearch?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<ReferralUserId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<String_Filter>;
  nameSearch?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReferralUser__Order>>>;
  organization?: InputMaybe<String_Filter>;
  phoneNumber?: InputMaybe<String_Filter>;
  phoneSearch?: InputMaybe<Scalars['String']['input']>;
  phonebookContact?: InputMaybe<PhonebookContact_RelationFilter>;
  phonebookContactId?: InputMaybe<AgencyPhonebookContactId_Filter>;
  role?: InputMaybe<String_Filter>;
  search?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Instant_Filter>;
};


export type QueryTicketsArgs = {
  _priority?: InputMaybe<String_Filter>;
  _source?: InputMaybe<String_Filter>;
  _topic?: InputMaybe<String_Filter>;
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAt?: InputMaybe<Instant_Filter>;
  createdBy?: InputMaybe<UserId_Filter>;
  createdBySystem?: InputMaybe<Boolean_Filter>;
  enableAgencyResponse?: InputMaybe<Boolean_Filter>;
  id?: InputMaybe<CommCenterTicketId_Filter>;
  label?: InputMaybe<CommCenterLabel_RelationFilter>;
  labelId?: InputMaybe<CommCenterLabelId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<CommCenterTicket__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
  phoneNumber?: InputMaybe<String_Filter>;
  phonebookContact?: InputMaybe<PhonebookContact_RelationFilter>;
  phonebookContactId?: InputMaybe<AgencyPhonebookContactId_Filter>;
  priority?: InputMaybe<Array<CommCenterLabelPriority>>;
  relatedVisitBroadcastId?: InputMaybe<VisitBroadcastId_Filter>;
  relatedVisitInstanceId?: InputMaybe<VisitInstanceId_Filter>;
  source?: InputMaybe<Array<CommCenterTicketSource>>;
  team?: InputMaybe<CommCenterTeam_RelationFilter>;
  teamId?: InputMaybe<CommCenterTeamId_Filter>;
  topic?: InputMaybe<Array<CommCenterTicketTopic>>;
  visitBroadcast?: InputMaybe<AgencyMemberVisitBroadcast_RelationFilter>;
  visitInstance?: InputMaybe<AgencyMemberVisitInstance_RelationFilter>;
};


export type QueryVisitAssignmentsArgs = {
  assignee?: InputMaybe<VisitAssignmentAssignee_RelationFilter>;
  assigneeId?: InputMaybe<Array<Scalars['AgencyMemberId']['input']>>;
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAtFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  createdAtTo?: InputMaybe<Scalars['LocalDate']['input']>;
  id?: InputMaybe<VisitAssignmentId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<VisitAssignment__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
  reasons?: InputMaybe<Array<VisitAssignmentReason>>;
  statuses?: InputMaybe<Array<VisitAssignmentStatus>>;
};


export type QueryVisitAssignmentsDistinctArgs = {
  assignee?: InputMaybe<VisitAssignmentAssignee_RelationFilter>;
  assigneeId?: InputMaybe<Array<Scalars['AgencyMemberId']['input']>>;
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAtFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  createdAtTo?: InputMaybe<Scalars['LocalDate']['input']>;
  id?: InputMaybe<VisitAssignmentId_Filter>;
  lastUnreadTicketAt?: InputMaybe<Instant_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<VisitAssignmentDistinct__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
  reasons?: InputMaybe<Array<VisitAssignmentReason>>;
  statuses?: InputMaybe<Array<VisitAssignmentStatus>>;
};


export type QueryVisitBroadcastsArgs = {
  canceledAt?: InputMaybe<Instant_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']['input']>;
  createdAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<VisitBroadcastId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberVisitBroadcast__Order>>>;
};


export type QueryVisitInstancesArgs = {
  caregiver?: InputMaybe<AgencyMemberCaregiver_RelationFilter>;
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAfter?: InputMaybe<Scalars['Instant']['input']>;
  id?: InputMaybe<VisitInstanceId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberVisitInstance__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
};


export type QueryWorkflowAvailableTaskInstancesArgs = {
  assignee?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  assigneeId?: InputMaybe<AgencyMemberId_Filter>;
  assigneeSearch?: InputMaybe<Scalars['String']['input']>;
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']['input']>>;
  clusterId?: InputMaybe<WorkflowTaskClusterId_Filter>;
  correlationKey?: InputMaybe<WorkflowDefinitionCorrelationKey_Filter>;
  createdAt?: InputMaybe<Instant_Filter>;
  createdAtFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  createdAtTo?: InputMaybe<Scalars['LocalDate']['input']>;
  description?: InputMaybe<String_Filter>;
  id?: InputMaybe<WorkflowTaskInstanceId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mandatory?: InputMaybe<Boolean_Filter>;
  name?: InputMaybe<String_Filter>;
  nameSearch?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberAvailableWorkflowTaskInstance__Order>>>;
  ownerId?: InputMaybe<AgencyMemberId_Filter>;
  patientIds?: InputMaybe<Array<Scalars['PatientId']['input']>>;
  priority?: InputMaybe<Int_Filter>;
  severity?: InputMaybe<String_Filter>;
  skillIds?: InputMaybe<Array<Scalars['WorkflowSkillId']['input']>>;
  taskNames?: InputMaybe<Array<Scalars['String']['input']>>;
  workflowDefinition?: InputMaybe<AgencyMemberWorkflowDefinition_RelationFilter>;
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
  workflowInstanceId?: InputMaybe<WorkflowInstanceId_Filter>;
  workflowTaskDefinitionId?: InputMaybe<String_Filter>;
};


export type QueryWorkflowDefinitionsArgs = {
  correlationKey?: InputMaybe<WorkflowDefinitionCorrelationKey_Filter>;
  createHumanTaskOnFailure?: InputMaybe<Boolean_Filter>;
  createdAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<WorkflowDefinitionId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowDefinition__Order>>>;
  owner?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  ownerId?: InputMaybe<AgencyMemberId_Filter>;
  priority?: InputMaybe<Int_Filter>;
  published?: InputMaybe<Boolean_Filter>;
  severity?: InputMaybe<String_Filter>;
  timeout?: InputMaybe<Int_Filter>;
  version?: InputMaybe<Int_Filter>;
};


export type QueryWorkflowInstancesArgs = {
  canceledAt?: InputMaybe<Instant_Filter>;
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']['input']>>;
  completedAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<WorkflowInstanceId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowInstance__Order>>>;
  patientIds?: InputMaybe<Array<Scalars['PatientId']['input']>>;
  startedAt?: InputMaybe<Instant_Filter>;
  startedAtFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  startedAtTo?: InputMaybe<Scalars['LocalDate']['input']>;
  status?: InputMaybe<String_Filter>;
  success?: InputMaybe<Boolean_Filter>;
  workflowDefinition?: InputMaybe<AgencyMemberWorkflowDefinition_RelationFilter>;
  workflowDefinitionCorrelationKey?: InputMaybe<WorkflowDefinitionCorrelationKey_Filter>;
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
  workflowManualStartedBy?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  workflowManualStartedById?: InputMaybe<AgencyMemberId_Filter>;
  workflowTriggerId?: InputMaybe<WorkflowDefinitionTriggerId_Filter>;
  workflowTriggerTaskInstanceId?: InputMaybe<WorkflowTaskInstanceId_Filter>;
  workflowTriggerType?: InputMaybe<String_Filter>;
};


export type QueryWorkflowTagsArgs = {
  id?: InputMaybe<WorkflowTagId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowTag__Order>>>;
};


export type QueryWorkflowTaskDefinitionsArgs = {
  id?: InputMaybe<String_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mandatory?: InputMaybe<Boolean_Filter>;
  name?: InputMaybe<String_Filter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowTaskDefinition__Order>>>;
  priority?: InputMaybe<Int_Filter>;
  severity?: InputMaybe<String_Filter>;
  type?: InputMaybe<String_Filter>;
  workflowDefinition?: InputMaybe<AgencyMemberWorkflowDefinition_RelationFilter>;
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
};


export type QueryWorkflowTaskInstanceInputsArgs = {
  entity?: InputMaybe<String_Filter>;
  fieldName?: InputMaybe<String_Filter>;
  isArray?: InputMaybe<Boolean_Filter>;
  isNullable?: InputMaybe<Boolean_Filter>;
  isOptional?: InputMaybe<Boolean_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowTaskInstanceInput__Order>>>;
  type?: InputMaybe<String_Filter>;
  value?: InputMaybe<String_Filter>;
  valueOrd?: InputMaybe<Int_Filter>;
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
  workflowInstanceId?: InputMaybe<WorkflowInstanceId_Filter>;
  workflowTaskDefinitionId?: InputMaybe<String_Filter>;
  workflowTaskInstance?: InputMaybe<AgencyMemberWorkflowTaskInstance_RelationFilter>;
  workflowTaskInstanceId?: InputMaybe<WorkflowTaskInstanceId_Filter>;
};


export type QueryWorkflowTaskInstanceTagsArgs = {
  createdAt?: InputMaybe<Instant_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowTaskInstanceTag__Order>>>;
  tagId?: InputMaybe<WorkflowTagId_Filter>;
  tagValue?: InputMaybe<String_Filter>;
  workflowTagDefinition?: InputMaybe<AgencyMemberWorkflowTag_RelationFilter>;
  workflowTaskInstance?: InputMaybe<AgencyMemberWorkflowTaskInstance_RelationFilter>;
  workflowTaskInstanceId?: InputMaybe<WorkflowTaskInstanceId_Filter>;
};


export type QueryWorkflowTaskInstancesArgs = {
  clusterId?: InputMaybe<WorkflowTaskClusterId_Filter>;
  clusterValue?: InputMaybe<String_Filter>;
  completedAt?: InputMaybe<Instant_Filter>;
  completedBy?: InputMaybe<AgencyMemberAgencyMember_RelationFilter>;
  completedById?: InputMaybe<AgencyMemberId_Filter>;
  createdAt?: InputMaybe<Instant_Filter>;
  id?: InputMaybe<WorkflowTaskInstanceId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgencyMemberWorkflowTaskInstance__Order>>>;
  priority?: InputMaybe<Int_Filter>;
  retryCount?: InputMaybe<Int_Filter>;
  severity?: InputMaybe<String_Filter>;
  success?: InputMaybe<Boolean_Filter>;
  systemTaskId?: InputMaybe<String_Filter>;
  systemTaskVersion?: InputMaybe<Int_Filter>;
  type?: InputMaybe<String_Filter>;
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
  workflowInstance?: InputMaybe<AgencyMemberWorkflowInstance_RelationFilter>;
  workflowInstanceId?: InputMaybe<WorkflowInstanceId_Filter>;
  workflowTaskDefinition?: InputMaybe<AgencyMemberWorkflowTaskDefinition_RelationFilter>;
  workflowTaskDefinitionId?: InputMaybe<String_Filter>;
};

export type ReferralUser = {
  __typename?: 'ReferralUser';
  createdAt: Scalars['Instant']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ReferralUserId']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  phonebookContact: PhonebookContact;
  phonebookContactId: Scalars['AgencyPhonebookContactId']['output'];
  role?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type ReferralUserConnection = {
  __typename?: 'ReferralUserConnection';
  /** The nodes that match the query */
  nodes: Array<ReferralUser>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

/** Filter result rows based on the value of a field */
export type ReferralUserId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['ReferralUserId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['ReferralUserId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['ReferralUserId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['ReferralUserId']['input']>>;
};

export type ReferralUser__Order = {
  /** Field to order by */
  field?: InputMaybe<ReferralUser__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum ReferralUser__OrderField {
  CreatedAt = 'createdAt',
  Email = 'email',
  Id = 'id',
  Name = 'name',
  Organization = 'organization',
  PhoneNumber = 'phoneNumber',
  PhonebookContactId = 'phonebookContactId',
  Role = 'role',
  UpdatedAt = 'updatedAt'
}

export type ServiceCode = {
  __typename?: 'ServiceCode';
  code: Scalars['String']['output'];
  id: Scalars['ServiceCodeId']['output'];
  isGlobal: Scalars['Boolean']['output'];
  patientAuthorizations: PatientAuthorizationConnection;
};


export type ServiceCodePatientAuthorizationsArgs = {
  authorizationCode?: InputMaybe<String_Filter>;
  endDate?: InputMaybe<LocalDate_Filter>;
  id?: InputMaybe<AuthorizationId_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientAuthorization__Order>>>;
  patient?: InputMaybe<Patient_RelationFilter>;
  patientContract?: InputMaybe<PatientContract_RelationFilter>;
  patientId?: InputMaybe<PatientId_Filter>;
  serviceCode?: InputMaybe<ServiceCode_RelationFilter>;
  startDate?: InputMaybe<LocalDate_Filter>;
};

/** Filter result rows based on the value of a field */
export type ServiceCodeId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['ServiceCodeId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['ServiceCodeId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['ServiceCodeId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['ServiceCodeId']['input']>>;
};

export type ServiceCode_RelationFilter = {
  /** Filter based on "code" field */
  code?: InputMaybe<String_Filter>;
  /** Filter based on "id" field */
  id?: InputMaybe<ServiceCodeId_Filter>;
  /** Filter based on "isGlobal" field */
  isGlobal?: InputMaybe<Boolean_Filter>;
};

/** Sort Direction (SQL ORDER BY ASC/DESC sorting) */
export enum SortDir {
  /** Ascending (default) */
  Asc = 'asc',
  /** Ascending with NULLs first */
  AscNullsFirst = 'ascNullsFirst',
  /** Descending */
  Desc = 'desc',
  /** Descending with NULLs last */
  DescNullsLast = 'descNullsLast'
}

export enum StateComplianceIssueType {
  ActiveInMedflytButHasTheWrongStatusInChrc = 'Active_in_Medflyt_but_has_the_wrong_status_in_CHRC',
  HasAtLeastOneVisitWithCicoButNoHireDate = 'Has_at_least_one_visit_with_CICO_but_no_hire_date',
  HasHireDateInMedflytButIsntRegisteredInHcr = 'Has_hire_date_in_Medflyt_but_isnt_registered_in_HCR',
  HasTerminationFileButNotOnTheRightStatusInMedflyt = 'Has_termination_file_but_not_on_the_right_status_in_Medflyt',
  InactiveInMedflytButNoSeparationDateInHcr = 'Inactive_in_Medflyt_but_no_separation_date_in_HCR',
  InactiveInMedflytButNotTerminatedInChrc = 'Inactive_in_Medflyt_but_not_terminated_in_CHRC',
  TerminatedInChrcButNoTerminationFileInMedflyt = 'Terminated_in_CHRC_but_no_termination_file_in_Medflyt'
}

/** Filter result rows based on the value of a field */
export type String_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Filter result rows based on the value of a field */
export type String_List_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Array<InputMaybe<Scalars['String']['input']>>>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Array<InputMaybe<Scalars['String']['input']>>>>;
};

/** Filter result rows based on the value of a field */
export type UserId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['UserId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['UserId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['UserId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['UserId']['input']>>;
};

export type VisitAssignment = {
  __typename?: 'VisitAssignment';
  assignee?: Maybe<VisitAssignmentAssignee>;
  caregiver?: Maybe<AgencyMemberCaregiver>;
  caregiverId?: Maybe<Scalars['CaregiverId']['output']>;
  createdAt: Scalars['Instant']['output'];
  id: Scalars['VisitAssignmentId']['output'];
  notes: VisitAssignmentNoteAssocConnection;
  patient: Patient;
  patientId: Scalars['PatientId']['output'];
  reason: VisitAssignmentReason;
  status: VisitAssignmentStatus;
  tickets: VisitAssignmentTicketAssocConnection;
  visitBroadcasts: VisitAssignmentVisitBroadcastAssocConnection;
  visitInstances: VisitAssignmentVisitInstanceAssocConnection;
};


export type VisitAssignmentNotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Note_RelationFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  visitAssignment?: InputMaybe<VisitAssignment_RelationFilter>;
};


export type VisitAssignmentTicketsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ticket?: InputMaybe<CommCenterTicket_RelationFilter>;
  visitAssignment?: InputMaybe<VisitAssignment_RelationFilter>;
};


export type VisitAssignmentVisitBroadcastsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  visitAssignment?: InputMaybe<VisitAssignment_RelationFilter>;
  visitBroadcast?: InputMaybe<AgencyMemberVisitBroadcast_RelationFilter>;
};


export type VisitAssignmentVisitInstancesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  visitAssignment?: InputMaybe<VisitAssignment_RelationFilter>;
  visitInstance?: InputMaybe<AgencyMemberVisitInstance_RelationFilter>;
};

export type VisitAssignmentAssignee = {
  __typename?: 'VisitAssignmentAssignee';
  agencyMember?: Maybe<AgencyMemberAgencyMember>;
  assignee_id?: Maybe<Scalars['AgencyMemberId']['output']>;
  assignment_id: Scalars['VisitAssignmentId']['output'];
  createdBy: AgencyMemberAgencyMember;
  created_at: Scalars['Instant']['output'];
  created_by: Scalars['AgencyMemberId']['output'];
  visitAssignment: VisitAssignment;
};

export type VisitAssignmentAssignee_RelationFilter = {
  /** Filter based on "assignee_id" field */
  assignee_id?: InputMaybe<AgencyMemberId_Filter>;
};

export type VisitAssignmentConnection = {
  __typename?: 'VisitAssignmentConnection';
  /** The nodes that match the query */
  nodes: Array<VisitAssignment>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type VisitAssignmentDistinct = {
  __typename?: 'VisitAssignmentDistinct';
  assignee?: Maybe<VisitAssignmentAssignee>;
  caregiver?: Maybe<AgencyMemberCaregiver>;
  caregiverId?: Maybe<Scalars['CaregiverId']['output']>;
  createdAt: Scalars['Instant']['output'];
  id: Scalars['VisitAssignmentId']['output'];
  lastUnreadTicketAt?: Maybe<Scalars['Instant']['output']>;
  notes: VisitAssignmentNoteAssocConnection;
  patient: Patient;
  patientId: Scalars['PatientId']['output'];
  reason: VisitAssignmentReason;
  resolvedCount: Scalars['Int']['output'];
  status: VisitAssignmentStatus;
  tickets: VisitAssignmentTicketAssocConnection;
  unresolvedCount: Scalars['Int']['output'];
  visitBroadcasts: VisitAssignmentVisitBroadcastAssocConnection;
  visitInstances: VisitAssignmentVisitInstanceAssocConnection;
};


export type VisitAssignmentDistinctNotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Note_RelationFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  visitAssignment?: InputMaybe<VisitAssignment_RelationFilter>;
};


export type VisitAssignmentDistinctTicketsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ticket?: InputMaybe<CommCenterTicket_RelationFilter>;
  visitAssignment?: InputMaybe<VisitAssignment_RelationFilter>;
};


export type VisitAssignmentDistinctVisitBroadcastsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  visitAssignment?: InputMaybe<VisitAssignment_RelationFilter>;
  visitBroadcast?: InputMaybe<AgencyMemberVisitBroadcast_RelationFilter>;
};


export type VisitAssignmentDistinctVisitInstancesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  visitAssignment?: InputMaybe<VisitAssignment_RelationFilter>;
  visitInstance?: InputMaybe<AgencyMemberVisitInstance_RelationFilter>;
};

export type VisitAssignmentDistinctConnection = {
  __typename?: 'VisitAssignmentDistinctConnection';
  /** The nodes that match the query */
  nodes: Array<VisitAssignmentDistinct>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type VisitAssignmentDistinct__Order = {
  /** Field to order by */
  field?: InputMaybe<VisitAssignmentDistinct__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum VisitAssignmentDistinct__OrderField {
  Reason = '_reason',
  Status = '_status',
  CaregiverId = 'caregiverId',
  CreatedAt = 'createdAt',
  Id = 'id',
  LastUnreadTicketAt = 'lastUnreadTicketAt',
  PatientId = 'patientId',
  ResolvedCount = 'resolvedCount',
  UnresolvedCount = 'unresolvedCount'
}

/** Filter result rows based on the value of a field */
export type VisitAssignmentId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['VisitAssignmentId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['VisitAssignmentId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['VisitAssignmentId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['VisitAssignmentId']['input']>>;
};

export type VisitAssignmentNoteAssoc = {
  __typename?: 'VisitAssignmentNoteAssoc';
  note: Note;
  noteId: Scalars['NoteId']['output'];
  visitAssignment: VisitAssignment;
  visitAssignmentId: Scalars['VisitAssignmentId']['output'];
};

export type VisitAssignmentNoteAssocConnection = {
  __typename?: 'VisitAssignmentNoteAssocConnection';
  /** The nodes that match the query */
  nodes: Array<VisitAssignmentNoteAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export enum VisitAssignmentReason {
  CannotAttendFirstVisit = 'CannotAttendFirstVisit',
  CannotAttendShift = 'CannotAttendShift',
  CannotAttendShiftChat = 'CannotAttendShiftChat',
  CannotAttendShiftLateClockInRobocall = 'CannotAttendShiftLateClockInRobocall',
  CannotAttendShiftRn = 'CannotAttendShiftRN',
  ChatRn = 'ChatRN',
  CoordinatorBroadcastedVisit = 'CoordinatorBroadcastedVisit',
  CoordinatorRemovedAllFutureVisits = 'CoordinatorRemovedAllFutureVisits',
  CoordinatorRemovedVisits = 'CoordinatorRemovedVisits',
  Default = 'Default',
  MissingClockIn = 'MissingClockIn',
  MissingPhysicianInfo = 'MissingPhysicianInfo',
  NoAnswerFirstVisitVerifyChat = 'NoAnswerFirstVisitVerifyChat',
  NoReplacementCancelledMoreThanOneShift = 'NoReplacementCancelledMoreThanOneShift',
  NoReplacementFirstMonthOfServices = 'NoReplacementFirstMonthOfServices',
  NursingVisitScheduling = 'NursingVisitScheduling',
  PatientCalled = 'PatientCalled',
  PatientMissedCall = 'PatientMissedCall',
  PatientMovedToSms = 'PatientMovedToSMS',
  PatientSentSms = 'PatientSentSMS',
  RnNote = 'RNNote',
  UnassignedVisit = 'UnassignedVisit',
  WantToStopWorkingWithPatientChat = 'WantToStopWorkingWithPatientChat'
}

export enum VisitAssignmentStatus {
  Resolved = 'Resolved',
  Unresolved = 'Unresolved'
}

export type VisitAssignmentTicketAssoc = {
  __typename?: 'VisitAssignmentTicketAssoc';
  commCenterTicketId: Scalars['CommCenterTicketId']['output'];
  relations: Array<Scalars['String']['output']>;
  ticket: CommCenterTicket;
  visitAssignment: VisitAssignment;
  visitAssignmentId: Scalars['VisitAssignmentId']['output'];
};

export type VisitAssignmentTicketAssocConnection = {
  __typename?: 'VisitAssignmentTicketAssocConnection';
  /** The nodes that match the query */
  nodes: Array<VisitAssignmentTicketAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type VisitAssignmentVisitBroadcastAssoc = {
  __typename?: 'VisitAssignmentVisitBroadcastAssoc';
  visitAssignment: VisitAssignment;
  visitAssignmentId: Scalars['VisitAssignmentId']['output'];
  visitBroadcast: AgencyMemberVisitBroadcast;
  visitBroadcastId: Scalars['VisitBroadcastId']['output'];
};

export type VisitAssignmentVisitBroadcastAssocConnection = {
  __typename?: 'VisitAssignmentVisitBroadcastAssocConnection';
  /** The nodes that match the query */
  nodes: Array<VisitAssignmentVisitBroadcastAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type VisitAssignmentVisitInstanceAssoc = {
  __typename?: 'VisitAssignmentVisitInstanceAssoc';
  visitAssignment: VisitAssignment;
  visitAssignmentId: Scalars['VisitAssignmentId']['output'];
  visitInstance: AgencyMemberVisitInstance;
  visitInstanceId: Scalars['VisitInstanceId']['output'];
};

export type VisitAssignmentVisitInstanceAssocConnection = {
  __typename?: 'VisitAssignmentVisitInstanceAssocConnection';
  /** The nodes that match the query */
  nodes: Array<VisitAssignmentVisitInstanceAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type VisitAssignment_RelationFilter = {
  assigneeId?: InputMaybe<Array<Scalars['AgencyMemberId']['input']>>;
  /** Filter based on "caregiverId" field */
  caregiverId?: InputMaybe<CaregiverId_Filter>;
  createdAtFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  createdAtTo?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Filter based on "id" field */
  id?: InputMaybe<VisitAssignmentId_Filter>;
  /** Filter based on "patientId" field */
  patientId?: InputMaybe<PatientId_Filter>;
  reasons?: InputMaybe<Array<VisitAssignmentReason>>;
  statuses?: InputMaybe<Array<VisitAssignmentStatus>>;
};

export type VisitAssignment__Order = {
  /** Field to order by */
  field?: InputMaybe<VisitAssignment__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum VisitAssignment__OrderField {
  Reason = '_reason',
  Status = '_status',
  CaregiverId = 'caregiverId',
  CreatedAt = 'createdAt',
  Id = 'id',
  PatientId = 'patientId'
}

export type VisitBroadcastAssoc = {
  __typename?: 'VisitBroadcastAssoc';
  visitBroadcast: AgencyMemberVisitBroadcast;
  visitBroadcastId: Scalars['VisitBroadcastId']['output'];
  visitInstanceId: Scalars['VisitInstanceId']['output'];
  visitInstances: AgencyMemberVisitInstance;
};

export type VisitBroadcastAssocConnection = {
  __typename?: 'VisitBroadcastAssocConnection';
  /** The nodes that match the query */
  nodes: Array<VisitBroadcastAssoc>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type VisitBroadcastBroadcastedTo = {
  __typename?: 'VisitBroadcastBroadcastedTo';
  caregiver: AgencyMemberCaregiver;
  caregiverId: Scalars['CaregiverId']['output'];
  visitBroadcast: AgencyMemberVisitBroadcast;
  visitBroadcastId: Scalars['VisitBroadcastId']['output'];
};

export type VisitBroadcastBroadcastedToConnection = {
  __typename?: 'VisitBroadcastBroadcastedToConnection';
  /** The nodes that match the query */
  nodes: Array<VisitBroadcastBroadcastedTo>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type VisitBroadcastBroadcastedTo__Order = {
  /** Field to order by */
  field?: InputMaybe<VisitBroadcastBroadcastedTo__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum VisitBroadcastBroadcastedTo__OrderField {
  CaregiverId = 'caregiverId'
}

export type VisitBroadcastCaregiverEngagement = {
  __typename?: 'VisitBroadcastCaregiverEngagement';
  acceptedTime: Scalars['Instant']['output'];
  active: Scalars['Boolean']['output'];
  cancelTime: Scalars['Instant']['output'];
  caregiver?: Maybe<AgencyMemberCaregiver>;
  caregiverId: Scalars['CaregiverId']['output'];
  createdAt: Scalars['Instant']['output'];
  id: Scalars['CaregiverVisitEngagementId']['output'];
  isRequestActive: Scalars['Boolean']['output'];
  moreDetailsViewedAt: Scalars['Instant']['output'];
  notInterestedReason: Scalars['String']['output'];
  notInterestedTime: Scalars['Instant']['output'];
  viewedAt: Scalars['Instant']['output'];
  visitBroadcast?: Maybe<AgencyMemberVisitBroadcast>;
  visitBroadcastId: Scalars['VisitBroadcastId']['output'];
};

export type VisitBroadcastCaregiverEngagementConnection = {
  __typename?: 'VisitBroadcastCaregiverEngagementConnection';
  /** The nodes that match the query */
  nodes: Array<VisitBroadcastCaregiverEngagement>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type VisitBroadcastCaregiverEngagement__Order = {
  /** Field to order by */
  field?: InputMaybe<VisitBroadcastCaregiverEngagement__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum VisitBroadcastCaregiverEngagement__OrderField {
  AcceptedTime = 'acceptedTime',
  Active = 'active',
  CancelTime = 'cancelTime',
  CaregiverId = 'caregiverId',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsRequestActive = 'isRequestActive',
  MoreDetailsViewedAt = 'moreDetailsViewedAt',
  NotInterestedReason = 'notInterestedReason',
  NotInterestedTime = 'notInterestedTime',
  ViewedAt = 'viewedAt',
  VisitBroadcastId = 'visitBroadcastId'
}

export type VisitBroadcastCaregiverOverlappingImportedVisits = {
  __typename?: 'VisitBroadcastCaregiverOverlappingImportedVisits';
  /** The caregiver's imported visit that overlaps */
  caregiverImportedVisit?: Maybe<AgencyMemberImportedVisit>;
  caregiverImportedVisitFromDifferentAgency: Scalars['Boolean']['output'];
  /** The VisitInstance in this broadcast that overlaps */
  visitBroadcastVisitInstance: AgencyMemberVisitInstance;
};

export type VisitBroadcastCaregiverOverlappingImportedVisitsConnection = {
  __typename?: 'VisitBroadcastCaregiverOverlappingImportedVisitsConnection';
  /** The nodes that match the query */
  nodes: Array<VisitBroadcastCaregiverOverlappingImportedVisits>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type VisitBroadcastCaregiverOverlappingVisits = {
  __typename?: 'VisitBroadcastCaregiverOverlappingVisits';
  /** The caregiver's visit that overlaps */
  caregiverVisitInstance?: Maybe<AgencyMemberVisitInstance>;
  caregiverVisitInstanceFromDifferentAgency: Scalars['Boolean']['output'];
  /** The VisitInstance in this broadcast that overlaps */
  visitBroadcastVisitInstance: AgencyMemberVisitInstance;
};

export type VisitBroadcastCaregiverOverlappingVisitsConnection = {
  __typename?: 'VisitBroadcastCaregiverOverlappingVisitsConnection';
  /** The nodes that match the query */
  nodes: Array<VisitBroadcastCaregiverOverlappingVisits>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

/** Filter result rows based on the value of a field */
export type VisitBroadcastId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['VisitBroadcastId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['VisitBroadcastId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['VisitBroadcastId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['VisitBroadcastId']['input']>>;
};

export type VisitBroadcastNotBroadcastedTo = {
  __typename?: 'VisitBroadcastNotBroadcastedTo';
  caregiverAvailabilityDaysConflict: Scalars['Boolean']['output'];
  caregiverDistanceToVisitMeters: Scalars['Float']['output'];
  caregiverHasOverlappingImportedVisits: Scalars['Boolean']['output'];
  caregiverHasOverlappingVisits: Scalars['Boolean']['output'];
  caregiverId: Scalars['CaregiverId']['output'];
  caregiverMarkedNotInterested: Scalars['Boolean']['output'];
  caregiverStatusMatches: Scalars['Boolean']['output'];
  caregiverWithinRadius: Scalars['Boolean']['output'];
  certificationMatches: Scalars['Boolean']['output'];
  genderMatches: Scalars['Boolean']['output'];
  languageMatches: Scalars['Boolean']['output'];
  /** The caregiver's imported visits that are overlapping with this VisitBroadcast */
  overlappingImportedVisits: VisitBroadcastCaregiverOverlappingImportedVisitsConnection;
  /** The caregiver's visits that are overlapping with this VisitBroadcast */
  overlappingVisits: VisitBroadcastCaregiverOverlappingVisitsConnection;
  visitWithinAvailabilityMaxDistance: Scalars['Boolean']['output'];
};


export type VisitBroadcastNotBroadcastedToOverlappingImportedVisitsArgs = {
  caregiverImportedVisit?: InputMaybe<AgencyMemberImportedVisit_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  visitBroadcastVisitInstance?: InputMaybe<AgencyMemberVisitInstance_RelationFilter>;
};


export type VisitBroadcastNotBroadcastedToOverlappingVisitsArgs = {
  caregiverVisitInstance?: InputMaybe<AgencyMemberVisitInstance_RelationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  visitBroadcastVisitInstance?: InputMaybe<AgencyMemberVisitInstance_RelationFilter>;
};

export type VisitBroadcastNotBroadcastedToConnection = {
  __typename?: 'VisitBroadcastNotBroadcastedToConnection';
  /** The nodes that match the query */
  nodes: Array<VisitBroadcastNotBroadcastedTo>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

export type VisitBroadcastNotBroadcastedTo__Order = {
  /** Field to order by */
  field?: InputMaybe<VisitBroadcastNotBroadcastedTo__OrderField>;
  /** Sort direction */
  sort?: InputMaybe<SortDir>;
};

export enum VisitBroadcastNotBroadcastedTo__OrderField {
  CaregiverId = 'caregiverId',
  CaregiverMarkedNotInterested = 'caregiverMarkedNotInterested'
}

export type VisitInstanceAuthorizationAllocation = {
  __typename?: 'VisitInstanceAuthorizationAllocation';
  authorization: PatientAuthorization;
  authorizationId: Scalars['AuthorizationId']['output'];
  minutesAllocated: Scalars['Int']['output'];
  visitInstance: AgencyMemberVisitInstance;
  visitInstanceId: Scalars['VisitInstanceId']['output'];
};

export type VisitInstanceAuthorizationAllocationConnection = {
  __typename?: 'VisitInstanceAuthorizationAllocationConnection';
  /** The nodes that match the query */
  nodes: Array<VisitInstanceAuthorizationAllocation>;
  /** The number of nodes that match the query */
  totalCount: Scalars['Int']['output'];
};

/** Filter result rows based on the value of a field */
export type VisitInstanceId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['VisitInstanceId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['VisitInstanceId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['VisitInstanceId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['VisitInstanceId']['input']>>;
};

/** Filter result rows based on the value of a field */
export type WorkflowDefinitionCorrelationKey_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['WorkflowDefinitionCorrelationKey']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['WorkflowDefinitionCorrelationKey']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['WorkflowDefinitionCorrelationKey']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['WorkflowDefinitionCorrelationKey']['input']>>;
};

/** Filter result rows based on the value of a field */
export type WorkflowDefinitionId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['WorkflowDefinitionId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['WorkflowDefinitionId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['WorkflowDefinitionId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['WorkflowDefinitionId']['input']>>;
};

/** Filter result rows based on the value of a field */
export type WorkflowDefinitionTriggerId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['WorkflowDefinitionTriggerId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['WorkflowDefinitionTriggerId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['WorkflowDefinitionTriggerId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['WorkflowDefinitionTriggerId']['input']>>;
};

/** Filter result rows based on the value of a field */
export type WorkflowInstanceId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['WorkflowInstanceId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['WorkflowInstanceId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['WorkflowInstanceId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['WorkflowInstanceId']['input']>>;
};

/** Filter result rows based on the value of a field */
export type WorkflowSkillId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['WorkflowSkillId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['WorkflowSkillId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['WorkflowSkillId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['WorkflowSkillId']['input']>>;
};

/** Filter result rows based on the value of a field */
export type WorkflowTagId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['WorkflowTagId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['WorkflowTagId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['WorkflowTagId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['WorkflowTagId']['input']>>;
};

/** Filter result rows based on the value of a field */
export type WorkflowTaskClusterId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['WorkflowTaskClusterId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['WorkflowTaskClusterId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['WorkflowTaskClusterId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['WorkflowTaskClusterId']['input']>>;
};

/** Filter result rows based on the value of a field */
export type WorkflowTaskInstanceId_Filter = {
  /** Equals (=) operator */
  eq?: InputMaybe<Scalars['WorkflowTaskInstanceId']['input']>;
  /** Equal to any of these values */
  in?: InputMaybe<Array<Scalars['WorkflowTaskInstanceId']['input']>>;
  /** Not-Equal (!=) operator */
  ne?: InputMaybe<Scalars['WorkflowTaskInstanceId']['input']>;
  /** Not equal to any of these values */
  nin?: InputMaybe<Array<Scalars['WorkflowTaskInstanceId']['input']>>;
};

export type WorkflowDashboardInstancesQueryVariables = Exact<{
  order: Array<InputMaybe<AgencyMemberWorkflowInstance__Order>> | InputMaybe<AgencyMemberWorkflowInstance__Order>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  workflowDefinitionCorrelationKey?: InputMaybe<WorkflowDefinitionCorrelationKey_Filter>;
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
  startedAtFrom?: InputMaybe<Scalars['LocalDate']['input']>;
  startedAtTo?: InputMaybe<Scalars['LocalDate']['input']>;
  status?: InputMaybe<String_Filter>;
  patientIds?: InputMaybe<Array<Scalars['PatientId']['input']> | Scalars['PatientId']['input']>;
  caregiverIds?: InputMaybe<Array<Scalars['CaregiverId']['input']> | Scalars['CaregiverId']['input']>;
}>;


export type WorkflowDashboardInstancesQuery = { __typename?: 'Query', workflowInstances: { __typename?: 'AgencyMemberWorkflowInstanceConnection', totalCount: number, nodes: Array<{ __typename?: 'AgencyMemberWorkflowInstance', id: schema.WorkflowInstanceId, origin: schema.components["schemas"]["WorkflowInstanceOrigin"], startedAt: Instant, completedAt?: Instant | null, status: string, input: schema.components["schemas"]["WorkflowExecutionValueObject"], workflowDefinitionId: schema.WorkflowDefinitionId, workflowDefinition: { __typename?: 'AgencyMemberWorkflowDefinition', version: number } }> } };

export type WorkflowDashboardDefinitionsQueryVariables = Exact<{
  workflowDefinitionId?: InputMaybe<WorkflowDefinitionId_Filter>;
  corrletionKey: WorkflowDefinitionCorrelationKey_Filter;
}>;


export type WorkflowDashboardDefinitionsQuery = { __typename?: 'Query', workflowDefinitions: { __typename?: 'AgencyMemberWorkflowDefinitionConnection', nodes: Array<{ __typename?: 'AgencyMemberWorkflowDefinition', correlationKey: schema.WorkflowDefinitionCorrelationKey, versions: { __typename?: 'AgencyMemberWorkflowDefinitionConnection', nodes: Array<{ __typename?: 'AgencyMemberWorkflowDefinition', id: schema.WorkflowDefinitionId, name: string, input: schema.components["schemas"]["WorkflowInputs"], version: number, published: boolean, createdAt: Instant, owner: { __typename?: 'AgencyMemberAgencyMember', id: schema.AgencyMemberId, full_name: string } }> } }> } };


export const WorkflowDashboardInstancesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkflowDashboardInstances"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgencyMemberWorkflowInstance__Order"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflowDefinitionCorrelationKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowDefinitionCorrelationKey_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflowDefinitionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowDefinitionId_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startedAtFrom"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startedAtTo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PatientId"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"caregiverIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaregiverId"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowInstances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"startedAtFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startedAtFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"startedAtTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startedAtTo"}}},{"kind":"Argument","name":{"kind":"Name","value":"workflowDefinitionCorrelationKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflowDefinitionCorrelationKey"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"patientIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"caregiverIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"caregiverIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"workflowDefinitionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflowDefinitionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"origin"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"input"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workflowDefinitionId"}},{"kind":"Field","name":{"kind":"Name","value":"workflowDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]}}]} as unknown as DocumentNode<WorkflowDashboardInstancesQuery, WorkflowDashboardInstancesQueryVariables>;
export const WorkflowDashboardDefinitionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkflowDashboardDefinitions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflowDefinitionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowDefinitionId_Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"corrletionKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowDefinitionCorrelationKey_Filter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowDefinitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflowDefinitionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"correlationKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"corrletionKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationKey"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"version"}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"input"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<WorkflowDashboardDefinitionsQuery, WorkflowDashboardDefinitionsQueryVariables>;

export type PermissionControlledField_boolean = PermissionControlledField<boolean>;
export type PermissionControlledField_DayOfWeek = PermissionControlledField<DayOfWeek>;
export type PermissionControlledField_Instant = PermissionControlledField<Instant>;
export type PermissionControlledField_LocalDate = PermissionControlledField<LocalDate>;
export type PermissionControlledField_LocalDateTime = PermissionControlledField<LocalDateTime>;
export type PermissionControlledField_LocalTime = PermissionControlledField<LocalTime>;
export type PermissionControlledField_number = PermissionControlledField<number>;
export type PermissionControlledField_string = PermissionControlledField<string>;
export type PermissionControlledField_nullable_boolean = PermissionControlledField<boolean | null>;
export type PermissionControlledField_nullable_DayOfWeek = PermissionControlledField<DayOfWeek | null>;
export type PermissionControlledField_nullable_Instant = PermissionControlledField<Instant | null>;
export type PermissionControlledField_nullable_LocalDate = PermissionControlledField<LocalDate | null>;
export type PermissionControlledField_nullable_LocalDateTime = PermissionControlledField<LocalDateTime | null>;
export type PermissionControlledField_nullable_LocalTime = PermissionControlledField<LocalTime | null>;
export type PermissionControlledField_nullable_number = PermissionControlledField<number | null>;
export type PermissionControlledField_nullable_string = PermissionControlledField<string | null>;
export interface PermissionControlledField<T> {
  value: PermissionControlledValue<T>;
  requiredReadPermission: schema.components["schemas"]["AgencyMemberPermission"] | null;
  requiredEditPermission: schema.components["schemas"]["AgencyMemberPermission"] | null;
}
export type PermissionControlledValue<T> =
  | PermissionControlledValue.Value<T>
  | PermissionControlledValue.PermissionDenied;
export namespace PermissionControlledValue {
  export interface Value<T> {
    type: "Value";
    value: T;
    canEdit: boolean;
  }
  export interface PermissionDenied {
    type: "PermissionDenied";
  }
}
